<template>
  <div style="margin-top: 70px">
    <v-container class="mt-5">
      <v-layout text-center wrap>
        <v-flex xs12>
          <v-flex>
            <v-card class="ma-auto pa-2" flat filled style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                ">
              <v-card-title>
                NEW
                <span class="red--text">FIRE</span>MATTER
              </v-card-title>

              <v-form class="ma-2" @submit.prevent="onLogin">
                <v-expand-transition>
                  <div>
                    <!-- <v-card
                        style="
                          background-color: black;
                          border-radius: 26px;
                          max-width: 500px;
                        "
                        outlined
                        tile
                        rounded
                        class="ma-auto"
                      > -->
                    <!-- <v-text-field
                          label="EMAIL"
                          name="email"
                          validate-on-blur
                          required
                          id="email"
                          class="ma-2"
                          outlined
                          v-model="email"
                          autofocus
                          clearable
                          :rules="[rules.email]"
                          type="email"
                          color="#a07800"
                        ></v-text-field>

                        <v-text-field
                          label="PASSWORD"
                          name="password"
                          required
                          id="password"
                          class="ma-2"
                          outlined
                          v-model="password"
                          validate-on-blur
                          clearable
                          type="password"
                          :rules="[rules.length(6)]"
                          counter="6"
                          color="#a07800"
                        ></v-text-field> -->
                    <v-text-field v-model="firstName" label="FIRST NAME (REQUIRED)" color="#2E5473" autofocus
                      style="max-width: 500px" class="ma-auto mb-1" clearable outlined dense></v-text-field>
                    <v-text-field v-model="lastName" label="LAST NAME (REQUIRED)" color="#2E5473" style="max-width: 500px"
                      class="ma-auto mb-1" clearable outlined dense></v-text-field>

                    <v-text-field v-model="email" label="EMAIL:" color="#2E5473" style="max-width: 500px"
                      class="ma-auto mb-1" dense outlined></v-text-field>
                    <v-text-field v-model="phone" label="PHONE NUMBER:" color="#2E5473" style="max-width: 500px"
                      class="ma-auto mb-1" hint="(###) ###-####" v-mask="phoneMask" dense outlined></v-text-field>
                    <v-text-field v-model="caseID" label="CASE ID:" color="#2E5473" style="max-width: 500px"
                      class="ma-auto mb-1" dense outlined></v-text-field>
                    <v-card style="border-radius: 26px; border: 1px solid #18CAE6; " outlined tile rounded class="ma-auto"
                      dense max-width="500px">
                      <v-card-text class="text-center font-weight-bold subtitle-2 ma-auto">
                        LOSS ADDRESS (REQUIRED)
                      </v-card-text>
                      <v-text-field v-model="streetAddress" label="STREET ADDRESS" color="#2E5473"
                        style="max-width: 400px" class="ma-auto mb-1" hint="123 Apple St. #4" dense
                        outlined></v-text-field>
                    </v-card>
                    <!-- </v-card> -->
                  </div>
                </v-expand-transition>
                <v-layout row class="mt-2">
                  <v-spacer></v-spacer>
                  <v-btn rounded text outlined class="mt-3" color="red">CANCEL</v-btn>
                  <v-spacer></v-spacer>

                  <v-btn rounded text outlined class="mt-3" color="green" :disabled="!streetAddress" @click="create"
                    id="sign-in-button">CONITNUE</v-btn>
                  <v-spacer></v-spacer>
                  <v-progress-circular color="green" v-if="loading" indeterminate></v-progress-circular>
                  <v-file-input class="ma-2 mt-6" autofocus outlined chips multiple label="UPLOAD EXISTING LIST"
                    ref="fileInput" @change="onFilePicked" accept=".xls, .xlsx" dense color="#2E5473"></v-file-input>

                  <v-spacer></v-spacer>
                </v-layout>
              </v-form>
            </v-card>
          </v-flex>
          <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import slugify from "slugify";

import firebase from "firebase";
import * as XLSX from "xlsx/xlsx.mjs";

/* load 'fs' for readFile and writeFile support */
import * as fs from "fs";
XLSX.set_fs(fs);

/* load 'stream' for stream support */
import { Readable } from "stream";
XLSX.stream.set_readable(Readable);

/* load the codepage support library for extended support with older formats  */
import * as cpexcel from "xlsx/dist/cpexcel.full.mjs";
XLSX.set_cptable(cpexcel);

export default {
  directives: {
    mask
  },

  data: () => ({
    //
    firstName: null,
    lastName: null,
    fullName: null,
    email: null,
    phone: null,
    caseID: null,
    streetAddress: null,
    phoneMask: "(###) ###-####",
    dateMask: "##/##/####",
    existingList: null,
    loading: false,
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: len => v =>
        (v || "").length >= len || `Invalid character length, required ${len}`
      // password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
      //   'Password must contain an upper case letter, a numeric character, and a special character',
    },
    clientList: [
      {
        FirstName: "Gina",
        LastName: "Jones",
        "Mailing Address": "30745 Pacific Coast Highway #279",
        "Mailing City": "Malibu",
        "Mailing State": "CA",
        "Mailing Zip Code": "90265",
        Email: "peter@petercjonesinc.com",
        "Secondary Email": "cmfrieze@gmail.com",
        Phone: "(646) 321-4448",
        SecondaryPhone: "(917) 929-9918",
        "Case Number": "0123",
        Client_ID: "135"
      },
      {
        FirstName: "NUMBER2",
        LastName: "Brandon",
        "Mailing Address": "15175 ANOTHER St Unit B",
        "Mailing City": "Moorpark",
        "Mailing State": "CA",
        "Mailing Zip Code": "93021",
        Email: "kebrandon@gmail.com",
        "Secondary Email": "kebrandon@hotmail.com",
        Phone: "(310) 867-0205",
        SecondaryPhone: "(310) 867-0099",
        "Case Number": "0120",
        Client_ID: "136"
      },
      {
        FirstName: "Sergei",
        LastName: "Evsikov",
        "Mailing Address": "6489 Kanan Dume rd",
        "Mailing City": "Malibu",
        "Mailing Zip Code": "90265",
        Email: "sevsikov@yahoo.com",
        Phone: "(310) 709-7495",
        SecondaryPhone: "(310) 729-2722",
        "Case Number": "0121",
        Client_ID: "137"
      }
      // {
      //   FirstName: "Alexander",
      //   LastName: "Rapoport",
      //   "Mailing Address": "P.O. Box 785",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing Zip Code": "91301",
      //   Email: "akr_68@yahoo.com",
      //   Phone: "(310) 483-3991",
      //   "Case Number": "0077",
      //   Client_ID: "138"
      // },
      // {
      //   FirstName: "Bogdan",
      //   LastName: "Ryabyshchuk",
      //   Email: "br@sdbr.net",
      //   "Secondary Email": "jto@sdbr.net",
      //   Phone: "(310) 699-1807",
      //   "Case Number": "0122",
      //   Client_ID: "139"
      // }
      // {
      //   FirstName: "Chantal",
      //   LastName: "Gillberg",
      //   Email: "chantal@gillbergdesign.com",
      //   Phone: "(310) 457-1768",
      //   "Case Number": "0076",
      //   Client_ID: "140"
      // },
      // {
      //   FirstName: "Will",
      //   LastName: "Carney",
      //   Email: "willcarney@hotmail.com",
      //   "Secondary Email": "hoganheaven@gmail.com",
      //   Phone: "(310) 666-3233",
      //   "Case Number": "0124",
      //   Client_ID: "141"
      // },
      // {
      //   FirstName: "Socorro",
      //   LastName: "Garcia",
      //   "Mailing Address": "2305 E Ball Rd #311",
      //   "Mailing City": "Anaheim",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "92806",
      //   Email: "socorro4Homes@yahoo.com",
      //   Phone: "(424) 395-6672",
      //   "Case Number": "0075",
      //   Client_ID: "142"
      // },
      // {
      //   FirstName: "James",
      //   LastName: "Collins",
      //   "Mailing Address": "30473 Mulholland Hwy #157",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing Zip Code": "91301",
      //   Email: "30473mulhollandhwy@gmail.com",
      //   Phone: "(805) 350-1728",
      //   "Case Number": "0074",
      //   Client_ID: "143"
      // },
      // {
      //   FirstName: "Steve",
      //   LastName: "Bernal",
      //   "Mailing Address": "27045 Helmond Drive",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "steve@stevebernal.com",
      //   "Secondary Email": "sherry@sherrymartyn.com",
      //   Phone: "(818) 694-1681",
      //   SecondaryPhone: "(310) 562-8360",
      //   "Case Number": "0130",
      //   Client_ID: "144"
      // }
      // {
      //   FirstName: "Gwenna",
      //   LastName: "Snider",
      //   "Mailing Address": "3506 Avenida Pantera",
      //   "Mailing City": "Carlsbad",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "92009",
      //   Email: "gwenna.snider@att.net",
      //   "Secondary Email": "gwenna.snider@att.net",
      //   Phone: "(858) 232-0036",
      //   SecondaryPhone: "(310) 490-4393",
      //   "Case Number": "0119",
      //   Client_ID: "145"
      // },
      // {
      //   FirstName: "Walczuk",
      //   LastName: "Anthony",
      //   "Mailing Address": "5537 Round Meadow Rd",
      //   "Mailing City": "Hidden Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91302",
      //   Email: "twmalibu@hotmail.com",
      //   "Secondary Email": "dana@shirleyofhollywood.com",
      //   Phone: "(310) 678-9408",
      //   SecondaryPhone: "(213) 216-8285",
      //   "Case Number": "0117",
      //   Client_ID: "146"
      // },
      // {
      //   FirstName: "Harout",
      //   LastName: "Tenekedjian",
      //   "Mailing Address": "1371 Whitehall Pl.",
      //   "Mailing City": "Westlake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91361",
      //   Email: "haroutt818@gmail.com",
      //   Phone: "(818) 687-6880",
      //   "Case Number": "0114",
      //   Client_ID: "147"
      // },
      // {
      //   FirstName: "Amanda",
      //   LastName: "Rucker",
      //   "Mailing Address": "5305 Captains Place",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "mbunrs@gmail.com",
      //   Phone: "(310) 383-1108",
      //   "Case Number": "0110",
      //   Client_ID: "148"
      // },
      // {
      //   FirstName: "Bryan",
      //   LastName: "Gabbard",
      //   "Mailing Address": "27162 Sea Vista Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "gabbard@defgrp.com",
      //   "Secondary Email": "kaygabbard@malibuumc.org",
      //   Phone: "(818) 519-3438",
      //   SecondaryPhone: "(310) 924-5743",
      //   "Case Number": "0126",
      //   Client_ID: "149"
      // },
      // {
      //   FirstName: "Robert",
      //   LastName: "Hays",
      //   "Mailing Address": "2040 E. Lakeshore Dr.",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "rchase7@aol.com",
      //   "Secondary Email": "jakeroberthays@gmail.com",
      //   Phone: "(818) 865-0536",
      //   SecondaryPhone: "(818) 216-4063",
      //   "Case Number": "0127",
      //   Client_ID: "150"
      // },
      // {
      //   FirstName: "Hershel",
      //   LastName: "Alford",
      //   "Mailing Address": "933 Alexandra Court",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "brenny_a@sbcglobal.net",
      //   "Secondary Email": "andreatorchia3@gmail.com",
      //   Phone: "(310) 717-8220",
      //   SecondaryPhone: "(310) 903-0509",
      //   "Case Number": "0128",
      //   Client_ID: "151"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Becker",
      //   "Mailing Address": "29711 Zuma Bay Way",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "mbeckerw@yahoo.com",
      //   Phone: "(310) 617-8247",
      //   "Case Number": "0129",
      //   Client_ID: "152"
      // },
      // {
      //   FirstName: "Frank",
      //   LastName: "Brooks",
      //   "Mailing Address": "5640 Calpine Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "77fbrooks@gmail.com",
      //   "Secondary Email": "77pbrooks@gmail.com",
      //   Phone: "(310) 924-5875",
      //   SecondaryPhone: "(310) 924-5875",
      //   "Case Number": "0131",
      //   Client_ID: "153"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Kostman",
      //   "Mailing Address": "18735 Chase St.",
      //   "Mailing City": "Northridge",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91324",
      //   Email: "citroenroen@gmail.com",
      //   Phone: "(818) 464-5444",
      //   "Case Number": "0133",
      //   Client_ID: "154"
      // },
      // {
      //   FirstName: "Katherine",
      //   LastName: "Row",
      //   "Mailing Address": "PO Box 4062",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "ktmalibu@gmail.com",
      //   Phone: "(310) 924-9837",
      //   "Case Number": "0135",
      //   Client_ID: "155"
      // },
      // {
      //   FirstName: "Kelly",
      //   LastName: "Pollack",
      //   "Mailing Address": "23410 Civic Center Wat, Ste C-7",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "kelly@tmg-la.com",
      //   Phone: "(310) 317-0753",
      //   "Case Number": "0058",
      //   Client_ID: "156"
      // },
      // {
      //   FirstName: "Kim",
      //   LastName: "Peterson",
      //   "Mailing Address": "5547 Old Salt Lane",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "loudmouthpeterson@aol.com",
      //   "Secondary Email": "kerrie@wildrootdesign.com",
      //   Phone: "(818) 874-3424",
      //   SecondaryPhone: "(310) 455-4159",
      //   "Case Number": "0057",
      //   Client_ID: "157"
      // },
      // {
      //   FirstName: "Christian",
      //   LastName: "Escario",
      //   "Mailing Address": "9200 Crescent Drive",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90046",
      //   Email: "christianescario@gmail.com",
      //   Phone: "(310) 666-4024",
      //   "Case Number": "0139",
      //   Client_ID: "158"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Mills",
      //   "Mailing Address": "6475 Zuma View Pl. #132",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "mickmills@verizon.net",
      //   Phone: "(310) 435-1213",
      //   "Case Number": "0140",
      //   Client_ID: "159"
      // },
      // {
      //   FirstName: "Joseph",
      //   LastName: "Hnot",
      //   "Mailing Address": "5625 Foxwood Drive Apt F",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "flash92133@yahoo.com",
      //   "Secondary Email": "ecvellano043@gmail.com",
      //   Phone: "(818) 991-5137",
      //   SecondaryPhone: "(714) 200-3567",
      //   "Case Number": "0141",
      //   Client_ID: "160"
      // },
      // {
      //   FirstName: "Yosef",
      //   LastName: "Rosen",
      //   "Mailing Address": "6451 Chesebro Road",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "shinymind.yos@gmail.com",
      //   "Secondary Email": "rebecca@shinymind.com",
      //   Phone: "(310) 597-9214",
      //   "Case Number": "0142",
      //   Client_ID: "161"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Starler",
      //   "Mailing Address": "1840 Century Park East #1900",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90067",
      //   Email: "starlerm@gtlaw.com",
      //   "Secondary Email": "drsuzan@starler.com",
      //   Phone: "(310) 658-4171",
      //   SecondaryPhone: "(310) 586-6506",
      //   "Case Number": "0143",
      //   Client_ID: "162"
      // },
      // {
      //   FirstName: "Paul",
      //   LastName: "Leonard",
      //   "Mailing Address": "30473 Mulholland Hwy #34",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "paulleonard277@yahoo.com",
      //   "Secondary Email": "stevierturnure@yahoo.com",
      //   Phone: "(818) 963-6291",
      //   SecondaryPhone: "(818) 431-3314",
      //   "Case Number": "0144",
      //   Client_ID: "163"
      // },
      // {
      //   FirstName: "Shannon",
      //   LastName: "Speed",
      //   "Mailing Address": "22745 Chamera Lane",
      //   "Mailing City": "Topanga",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90290",
      //   Email: "shannonspeed13@gmail.com",
      //   Phone: "(512) 470-0341",
      //   "Case Number": "0145",
      //   Client_ID: "164"
      // },
      // {
      //   FirstName: "Gareth",
      //   LastName: "Alford",
      //   "Mailing Address": "11 Huina Place",
      //   "Mailing City": "Kula",
      //   "Mailing State": "Hawaii",
      //   "Mailing Zip Code": "96790",
      //   Email: "bogeyfree68@twc.com",
      //   Phone: "(808) 269-1638",
      //   "Case Number": "0146",
      //   Client_ID: "165"
      // },
      // {
      //   FirstName: "John",
      //   LastName: "Bard",
      //   "Mailing Address": "1215 Calle Lozano",
      //   "Mailing City": "Camarillo",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "93012",
      //   Email: "johnjbard@gmail.com",
      //   "Secondary Email": "ninabard@verizon.net",
      //   Phone: "(310) 384-2827",
      //   SecondaryPhone: "(310) 924-0380",
      //   "Case Number": "0147",
      //   Client_ID: "166"
      // },
      // {
      //   FirstName: "Kaliko",
      //   LastName: "Farms LLC",
      //   "Mailing Address": "5613 Foxwood Rd. Apt E.",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "kaliko.orian@gmail.com",
      //   Phone: "(310) 460-9951",
      //   "Case Number": "0148",
      //   Client_ID: "167"
      // },
      // {
      //   FirstName: "David",
      //   LastName: "Lambert",
      //   "Mailing Address": "PO Box 1362",
      //   "Mailing City": "Wilson",
      //   "Mailing State": "WY",
      //   "Mailing Zip Code": "83014",
      //   Email: "dblemail@gmail.com",
      //   "Secondary Email": "pattitoliver@aol.com",
      //   Phone: "(310) 980-3179",
      //   SecondaryPhone: "(310) 456-4561",
      //   "Case Number": "0149",
      //   Client_ID: "168"
      // },
      // {
      //   FirstName: "Jennifer",
      //   LastName: "Matthew",
      //   "Mailing Address": "30070 Triunfo Dr.",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "jenniferkmatthew@yahoo.com",
      //   "Secondary Email": "mikemanfrommo@yahoo.com",
      //   Phone: "(818) 667-7954",
      //   SecondaryPhone: "(310) 729-6698",
      //   "Case Number": "0150",
      //   Client_ID: "169"
      // },
      // {
      //   FirstName: "Sandro",
      //   LastName: "Splendore",
      //   "Mailing Address": "28215 Via Acero Street",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "sandro@20atm.com",
      //   Phone: "(323) 360-1554",
      //   "Case Number": "0151",
      //   Client_ID: "170"
      // },
      // {
      //   FirstName: "20 ATM, LLC",
      //   "Mailing Address": "28215 via Acero Street",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "sandro@20atm.com",
      //   Phone: "(323) 360-1554",
      //   "Case Number": "0152",
      //   Client_ID: "171"
      // },
      // {
      //   FirstName: "Ryan",
      //   LastName: "Coyne",
      //   "Mailing Address": "PO Box 1403",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91376",
      //   Email: "lomprez@gmail.com",
      //   "Secondary Email": "italish4@hotmail.com",
      //   Phone: "(818) 428-8118",
      //   SecondaryPhone: "(818) 661-9450",
      //   "Case Number": "0155",
      //   Client_ID: "172"
      // },
      // {
      //   FirstName: "Oak Grove Development, LLC",
      //   "Mailing Address": "5737 Kanan Rd. #171",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "yos@shinymind.com",
      //   Phone: "(310) 597-9214",
      //   "Case Number": "0156",
      //   Client_ID: "173"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Mullally",
      //   "Mailing Address": "11848 Ebbtide Lane",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "4ma2ca@gmail.com",
      //   "Secondary Email": "4ma2ca@gmail.com",
      //   Phone: "(617) 429-5752",
      //   SecondaryPhone: "(617) 429-6245",
      //   "Case Number": "0157",
      //   Client_ID: "174"
      // },
      // {
      //   FirstName: "Brad Howe, Inc.",
      //   "Mailing Address": "1718 Albion Street",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90031",
      //   Email: "bradhowe@bradhowe.com",
      //   Phone: "(818) 519-6035",
      //   "Case Number": "0153",
      //   Client_ID: "175"
      // },
      // {
      //   FirstName: "Richard",
      //   LastName: "Dorfman",
      //   "Mailing Address": "6855 Dume Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "rexfarms@earthlink.net",
      //   Phone: "(310) 266-6648",
      //   "Case Number": "0154",
      //   Client_ID: "176"
      // },
      // {
      //   FirstName: "James",
      //   LastName: "Baer",
      //   "Mailing Address": "6621 Soundview Dr. NE",
      //   "Mailing City": "Tacoma",
      //   "Mailing State": "Washington",
      //   "Mailing Zip Code": "98422",
      //   Email: "jmbaer3@gmail.com",
      //   "Secondary Email": "elainebaer@gmail.com",
      //   Phone: "(310) 804-4474",
      //   SecondaryPhone: "(310) 283-5773",
      //   "Case Number": "0158",
      //   Client_ID: "177"
      // },
      // {
      //   FirstName: "Milton",
      //   LastName: "Christopher",
      //   "Mailing Address": "5651 Pansy Street",
      //   "Mailing City": "Simi Valley",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "93063",
      //   Email: "gchrisbiz@gmail.com",
      //   Phone: "(818) 231-1452",
      //   SecondaryPhone: "(310) 218-9911",
      //   "Case Number": "0159",
      //   Client_ID: "178"
      // },
      // {
      //   FirstName: "Randall",
      //   LastName: "Couch",
      //   "Mailing Address": "30473 Mulholland Hwy Spc. 33",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "couchelec@yahoo.com",
      //   Phone: "(818) 706-1869",
      //   SecondaryPhone: "(805) 816-0614",
      //   "Case Number": "0160",
      //   Client_ID: "179"
      // },
      // {
      //   FirstName: "Stephanie",
      //   LastName: "Proudman",
      //   "Mailing Address": "967 Blue Mountain Circle",
      //   "Mailing City": "West Lake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91362",
      //   Email: "stephanieproudman@yahoo.com",
      //   Phone: "(310) 748-9198",
      //   "Case Number": "0108",
      //   Client_ID: "180"
      // },
      // {
      //   FirstName: "Stephen",
      //   LastName: "Brown",
      //   "Mailing Address": "532 Moonrise Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "brown2020@gmail.com",
      //   "Secondary Email": "pattybrown@me.com",
      //   Phone: "(650) 888-8775",
      //   SecondaryPhone: "(650) 454-5558",
      //   "Case Number": "0163",
      //   Client_ID: "181"
      // },
      // {
      //   FirstName: "Ignite Channel Inc.",
      //   "Mailing Address": "30765 Pacific Coast Highway",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "brown2020@gmail.com",
      //   Phone: "(650) 888-8775",
      //   "Case Number": "0164",
      //   Client_ID: "182"
      // },
      // {
      //   FirstName: "Ignite Channel. Inc",
      //   "Mailing Address": "30765 Pacific Coast Highway Suite 354",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "brown2020@gmail.com",
      //   Phone: "(650) 888-8775",
      //   "Case Number": "0164",
      //   Client_ID: "183"
      // },
      // {
      //   FirstName: "Marsha",
      //   LastName: "Maus",
      //   "Mailing Address": "28448 Renee Dr.",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "marshamaus@gmail.com",
      //   Phone: "(310) 455-2385",
      //   "Case Number": "0165",
      //   Client_ID: "184"
      // },
      // {
      //   FirstName: "Wandermere, LLC",
      //   "Mailing Address": "21342 Entrada Rd.",
      //   "Mailing City": "Topanga",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90290",
      //   Email: "kerrie@wildrootdesign.com",
      //   Phone: "(424) 744-1500",
      //   SecondaryPhone: "(310) 455-4159",
      //   "Case Number": "0138",
      //   Client_ID: "185"
      // },
      // {
      //   FirstName: "Lillian J.",
      //   LastName: "Cunningham",
      //   "Mailing Address": "123 Ka Drive",
      //   "Mailing City": "Kula",
      //   "Mailing State": "Hawaii",
      //   "Mailing Zip Code": "96790",
      //   Email: "lillyjtucci@outlook.com",
      //   Phone: "(808) 276-2875",
      //   "Case Number": "0161",
      //   Client_ID: "186"
      // },
      // {
      //   FirstName: "Joe",
      //   LastName: "Fosnot",
      //   "Mailing Address": "5850 Canoga Ave 4th Floor",
      //   "Mailing City": "Woodland Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91367",
      //   Email: "jsfosnot@gmail.com",
      //   "Secondary Email": "suzifosnot@aol.com",
      //   Phone: "(818) 802-4440",
      //   SecondaryPhone: "(818) 203-1020",
      //   "Case Number": "0066",
      //   Client_ID: "187"
      // },
      // {
      //   FirstName: "Jacob",
      //   LastName: "Johnson",
      //   "Mailing Address": "2115 Squire Dobbins Drive",
      //   "Mailing City": "Sugar Land",
      //   "Mailing State": "Texas",
      //   "Mailing Zip Code": "77478",
      //   Email: "jacobderek@yahoo.com",
      //   "Secondary Email": "autumnjohnson@me.com",
      //   Phone: "(404) 951-5005",
      //   SecondaryPhone: "(404) 825-2565",
      //   "Case Number": "0125",
      //   Client_ID: "188"
      // },
      // {
      //   FirstName: "Sandra",
      //   LastName: "Kemp",
      //   "Mailing Address": "27162 Sea Vista Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "slkemp48@gmail.com",
      //   Phone: "(310) 922-2254",
      //   "Case Number": "0132",
      //   Client_ID: "189"
      // },
      // {
      //   FirstName: "Limelight Herbals LLC",
      //   "Mailing Address": "4789 Latigo Canyon Road",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "natasha@honanworld.com",
      //   Phone: "(310) 457-4964",
      //   "Case Number": "0134",
      //   Client_ID: "190"
      // },
      // {
      //   FirstName: "Lynn",
      //   LastName: "Norton",
      //   "Mailing Address": "1401 La Paz Drive",
      //   "Mailing City": "Ojai",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "93023",
      //   Email: "lynorton@verizon.net",
      //   Phone: "(310) 457-6925",
      //   "Case Number": "0162",
      //   Client_ID: "191"
      // },
      // {
      //   FirstName: "David M.",
      //   LastName: "Pepper",
      //   "Mailing Address": "5830 las Virgenes Road #469",
      //   "Mailing City": "Calabasas",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91302",
      //   Email: "wallywally409@gmail.com",
      //   "Secondary Email": "singopera4evr@gmail.com",
      //   Phone: "(310) 924-5644",
      //   SecondaryPhone: "(310) 924-5645",
      //   "Case Number": "0167",
      //   Client_ID: "192"
      // },
      // {
      //   Client_ID: "193"
      // },
      // {
      //   FirstName: "Tomlinson Management Group, INC.",
      //   "Mailing Address": "23410 Civic Center Way, Ste E-7",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "kelly@tmg-la.com",
      //   Phone: "(310) 317-0753",
      //   "Case Number": "0137",
      //   Client_ID: "194"
      // },
      // {
      //   FirstName: "George",
      //   LastName: "Colman",
      //   "Mailing Address": "5676 Colodny Drive",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing Zip Code": "91301",
      //   Email: "gcolman@sacfirm.com",
      //   "Secondary Email": "gkcolman@pacbell.net",
      //   Phone: "(818) 889-6727",
      //   "Case Number": "0166",
      //   Client_ID: "195"
      // },
      // {
      //   FirstName: "Melody Riggs",
      //   LastName: "White",
      //   "Mailing Address": "PO Box 651",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91376",
      //   Email: "melodyriggs184@gmail.com",
      //   "Secondary Email": "tlanagan@gmail.com",
      //   Phone: "(818) 235-3167",
      //   SecondaryPhone: "(805) 559-5853",
      //   "Case Number": "0168",
      //   Client_ID: "196"
      // },
      // {
      //   FirstName: "Corynne",
      //   LastName: "Colman",
      //   "Mailing Address": "5676 Colony Drive",
      //   "Mailing City": "Agoura hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "corynnecolman@gmail.com",
      //   Phone: "(818) 422-9922",
      //   "Case Number": "0166",
      //   Client_ID: "197"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Bixler",
      //   "Mailing Address": "26600 Ocean View Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "bixbiller@gmail.com",
      //   "Secondary Email": "lesbixler@gmail.com",
      //   Phone: "(310) 457-8024",
      //   SecondaryPhone: "(310) 924-4439",
      //   "Case Number": "0169",
      //   Client_ID: "199"
      // },
      // {
      //   FirstName: "Eric",
      //   LastName: "Broxham",
      //   "Mailing Address": "11866 Ebbtide Lane",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "ericbroxham@gmail.com",
      //   "Secondary Email": "reneebroxham@gmail.com",
      //   Phone: "(214) 205-4947",
      //   SecondaryPhone: "(310) 710-9584",
      //   "Case Number": "0170",
      //   Client_ID: "200"
      // },
      // {
      //   Client_ID: "201"
      // },
      // {
      //   FirstName: "Ron",
      //   LastName: "Glover",
      //   "Mailing Address": "5737 Kanan Rd. #563",
      //   "Mailing City": "Agoura",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "ronglover57@gmail.com",
      //   "Secondary Email": "michelleinmalibu@gmail.com",
      //   Phone: "(818) 216-9977",
      //   SecondaryPhone: "(818) 687-5779",
      //   "Case Number": "0171",
      //   Client_ID: "202"
      // },
      // {
      //   FirstName: "Richard",
      //   LastName: "Schirtzer",
      //   "Mailing Address": "865 S. Figueroa Street 10th Floor",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90017",
      //   Email: "richardschirtzer@quinnemanuel.com",
      //   "Secondary Email": "diane.namm@gmail.com",
      //   Phone: "(213) 327-8267",
      //   SecondaryPhone: "(310) 428-8713",
      //   "Case Number": "0173",
      //   Client_ID: "203"
      // },
      // {
      //   FirstName: "Tiffany",
      //   LastName: "Woodring",
      //   "Mailing Address": "5737 Kanan Rd #563",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "tiffanynwoodring@gmail.com",
      //   Phone: "(818) 687-5719",
      //   "Case Number": "0174",
      //   Client_ID: "204"
      // },
      // {
      //   FirstName: "Laurie",
      //   LastName: "Albert",
      //   "Mailing Address": "6924 Grasswood Ave",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "california",
      //   "Mailing Zip Code": "90265",
      //   Email: "lauriealbert@gmail.com",
      //   Phone: "(310) 589-5919",
      //   SecondaryPhone: "(310) 560-2323",
      //   "Case Number": "0175",
      //   Client_ID: "205"
      // },
      // {
      //   FirstName: "Bridget",
      //   LastName: "Bernal",
      //   "Mailing Address": "27045 Helmond Drive",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "bridgetmbernal@gmail.com",
      //   Phone: "(808) 492-4172",
      //   "Case Number": "0130",
      //   Client_ID: "206"
      // },
      // {
      //   FirstName: "Kent",
      //   LastName: "Colberg",
      //   Client_ID: "207"
      // },
      // {
      //   FirstName: "Steve",
      //   LastName: "LeGassick",
      //   "Mailing Address": "807 Crestmoore Place",
      //   "Mailing City": "Venice",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90291",
      //   Email: "steven@oseamalibu.com",
      //   "Secondary Email": "jenefer@oseamalibu.com",
      //   Phone: "(310) 924-4648",
      //   SecondaryPhone: "(310) 924-1182",
      //   "Case Number": "0176",
      //   Client_ID: "208"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Wibben",
      //   "Mailing Address": "2419 Chauncy Pl",
      //   "Mailing City": "Riverside",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "92506",
      //   Email: "mike@wibben.net",
      //   Phone: "(951) 675-9497",
      //   "Case Number": "0177",
      //   Client_ID: "209"
      // },
      // {
      //   FirstName: "Lynda V.",
      //   LastName: "Pingatore",
      //   "Mailing Address": "4720 Park Granada #210",
      //   "Mailing City": "Calabasas",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91302",
      //   Email: "lyndapingatore@yahoo.com",
      //   Phone: "(310) 924-0251",
      //   "Case Number": "0178",
      //   Client_ID: "210"
      // },
      // {
      //   FirstName: "Britlyn Courtney",
      //   LastName: "Coleman",
      //   "Mailing Address": "33397 Mulholland Highway",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "bccoleman31@gmail.com",
      //   "Secondary Email": "jordanjacob35@gmail.com",
      //   Phone: "(310) 467-1414",
      //   SecondaryPhone: "(760) 914-3773",
      //   "Case Number": "0180",
      //   Client_ID: "211"
      // },
      // {
      //   FirstName: "Michael S.",
      //   LastName: "Hart",
      //   "Mailing Address": "1804 Newell Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "cactusmartwaterwise@gmail.com",
      //   "Secondary Email": "julieh3710@yahoo.com",
      //   Phone: "(310) 985-5054",
      //   SecondaryPhone: "(310) 617-2174",
      //   "Case Number": "0181",
      //   Client_ID: "212"
      // },
      // {
      //   FirstName: "Thomas",
      //   LastName: "Molloy",
      //   "Mailing Address": "29549 Harvester Road",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "tomsmolloy@yahoo.com",
      //   "Secondary Email": "alanschimpff@netscape.net",
      //   Phone: "(310) 579-1758",
      //   SecondaryPhone: "(310) 579-5230",
      //   "Case Number": "0182",
      //   Client_ID: "213"
      // },
      // {
      //   FirstName: "Jason",
      //   LastName: "Speed",
      //   "Mailing Address": "30473 Mulholland Highway #96",
      //   "Mailing City": "Agoura",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "jasonjspeed@gmail.com",
      //   Phone: "(310) 383-9171",
      //   "Case Number": "0183",
      //   Client_ID: "214"
      // },
      // {
      //   FirstName: "Vanya",
      //   LastName: "Pavloff",
      //   "Mailing Address": "PO Box 6492",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90264",
      //   Email: "vaniapavloff@yahoo.com",
      //   Phone: "(310) 924-9061",
      //   "Case Number": "0184",
      //   Client_ID: "215"
      // },
      // {
      //   FirstName: "James",
      //   LastName: "Tomlinson",
      //   "Mailing Address": "26723  Shore Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "jimtomlinson@dwt.com",
      //   "Secondary Email": "jktomlinson@comcast.net",
      //   Phone: "(703) 963-3840",
      //   SecondaryPhone: "(703) 887-1765",
      //   "Case Number": "0185",
      //   Client_ID: "216"
      // },
      // {
      //   FirstName: "Vincent",
      //   LastName: "Tortell",
      //   "Mailing Address": "5350 Oak Park Lane #158",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "vtortell@gmail.com",
      //   Phone: "(747) 222-4496",
      //   "Case Number": "0186",
      //   Client_ID: "217"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Kneisley",
      //   "Mailing Address": "201 West Vineyard Ave. Apt #126",
      //   "Mailing City": "Oxnard",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "93036",
      //   Email: "kneisleymichael@yahoo.com",
      //   "Secondary Email": "kneisleymiriah@yahoo.com",
      //   Phone: "(626) 221-2783",
      //   SecondaryPhone: "(626) 260-8529",
      //   "Case Number": "0187",
      //   Client_ID: "218"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Patterson",
      //   "Mailing Address": "5877 Deerhead Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "bill@crosscreekentertain.com",
      //   "Secondary Email": "renapatt@gmail.com",
      //   Phone: "(310) 493-9729",
      //   SecondaryPhone: "(310) 699-7172",
      //   "Case Number": "0188",
      //   Client_ID: "219"
      // },
      // {
      //   FirstName: "Thomas F.",
      //   LastName: "McCahon",
      //   "Mailing Address": "670 E. Carlisle Road",
      //   "Mailing City": "West Lake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91361",
      //   Email: "tfmccahon@aol.com",
      //   Phone: "(805) 495-9543",
      //   "Case Number": "0189",
      //   Client_ID: "220"
      // },
      // {
      //   FirstName: "Wendy",
      //   LastName: "McCahon",
      //   "Mailing Address": "2728 E. Ponderosa Dr., Apt #107",
      //   "Mailing City": "Camarillo",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "93010",
      //   Email: "wamccahon@gmail.com",
      //   Phone: "(805) 559-5141",
      //   "Case Number": "0190",
      //   Client_ID: "221"
      // },
      // {
      //   FirstName: "Weston T.",
      //   LastName: "McCahon",
      //   "Mailing Address": "670 E. Carlisle Road",
      //   "Mailing City": "Westlake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91361",
      //   Email: "schro.si@gmail.com",
      //   Phone: "(805) 495-3162",
      //   "Case Number": "0191",
      //   Client_ID: "222"
      // },
      // {
      //   FirstName: "Travis S.",
      //   LastName: "McCahon",
      //   "Mailing Address": "670 E. Carlisle Road",
      //   "Mailing City": "Westlake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91361",
      //   Email: "tsmbusi@gmail.com",
      //   Phone: "(805) 906-0644",
      //   "Case Number": "0192",
      //   Client_ID: "223"
      // },
      // {
      //   FirstName: "Margo",
      //   LastName: "Montgomery",
      //   "Mailing Address": "292 Whiteside Place",
      //   "Mailing City": "Thousand Oaks",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91362",
      //   Email: "margo.montgomery@gmail.com",
      //   Phone: "(805) 338-9347",
      //   "Case Number": "0193",
      //   Client_ID: "224"
      // },
      // {
      //   FirstName: "Emiko Madison",
      //   LastName: "Nakanishi",
      //   "Mailing Address": "136 Ventana Ct.",
      //   "Mailing City": "Thousand Oaks",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91360",
      //   Email: "emikomadison@yahoo.com",
      //   Phone: "(805) 390-3439",
      //   "Case Number": "0194",
      //   Client_ID: "225"
      // },
      // {
      //   FirstName: "Desmond",
      //   LastName: "Coyle",
      //   "Mailing Address": "22241 PCH Suite D",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "descoyle@aol.com",
      //   "Secondary Email": "amibu@aol.com",
      //   Phone: "(310) 924-9105",
      //   SecondaryPhone: "(310) 924-4656",
      //   "Case Number": "0195",
      //   Client_ID: "226"
      // },
      // {
      //   FirstName: "Luis",
      //   LastName: "Horna",
      //   "Mailing Address": "PO Box 432",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "luchohorna60@yahoo.com",
      //   "Secondary Email": "luishorna@dpss.lacounty.gov",
      //   Phone: "(310) 892-4740",
      //   "Case Number": "0196",
      //   Client_ID: "227"
      // },
      // {
      //   FirstName: "Meghan",
      //   LastName: "Hansen",
      //   "Mailing Address": "23838 Pacific Coast Highway #2414",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "malibumusicgirl@aol.com",
      //   "Secondary Email": "meghansen90265@gmail.com",
      //   Phone: "(310) 562-3563",
      //   "Case Number": "0197",
      //   Client_ID: "228"
      // },
      // {
      //   FirstName: "Lee",
      //   LastName: "Raphael",
      //   "Mailing Address": "5232 Avenida Hacienda",
      //   "Mailing City": "Tarzana",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91356",
      //   Email: "lraphael@pralc",
      //   Phone: "(818) 621-6262",
      //   SecondaryPhone: "(818) 705-8508",
      //   "Case Number": "0198",
      //   Client_ID: "229"
      // },
      // {
      //   Client_ID: "230"
      // },
      // {
      //   FirstName: "Sean",
      //   LastName: "Montgomery",
      //   "Mailing Address": "4117 Towhee Drive",
      //   "Mailing City": "Calabasas",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91302",
      //   Email: "towhee@xano.com",
      //   Phone: "(310) 382-4397",
      //   "Case Number": "0199",
      //   Client_ID: "231"
      // },
      // {
      //   FirstName: "R. Duke",
      //   LastName: "Blackwood",
      //   "Mailing Address": "3500 Bayberry Lane",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "malibuduke@verizon.net",
      //   "Secondary Email": "anneblackwood@verizon.net",
      //   Phone: "(424) 382-6380",
      //   SecondaryPhone: "(310) 309-7489",
      //   "Case Number": "200",
      //   Client_ID: "232"
      // },
      // {
      //   FirstName: "Invent.ly LLC",
      //   "Mailing Address": "30765 Pacific Coast Hwy #354",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "brown2020@gmail.com",
      //   Phone: "(650) 888-8775",
      //   "Case Number": "201",
      //   Client_ID: "233"
      // },
      // {
      //   FirstName: "Alicia",
      //   LastName: "Holt",
      //   "Mailing Address": "4021 Via Nivel",
      //   "Mailing City": "Palos Verdes Estates",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90274",
      //   Email: "aliciadholt@yahoo.com",
      //   "Secondary Email": "vashtiholt@gmail.com",
      //   Phone: "(626) 487-1937",
      //   SecondaryPhone: "(510) 928-1062",
      //   "Case Number": "208",
      //   Client_ID: "234"
      // },
      // {
      //   FirstName: "John",
      //   LastName: "Garcia",
      //   "Mailing Address": "2025 Ocean Drive",
      //   "Mailing City": "Oxnard",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "93035",
      //   Email: "johngarciatudio@gmail.com",
      //   Phone: "(310) 317-0600",
      //   "Case Number": "202",
      //   Client_ID: "235"
      // },
      // {
      //   FirstName: "Ken",
      //   LastName: "Chiate",
      //   "Mailing Address": "20628 Rockcroft Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "kenchiate@quinnemanuel.com",
      //   Phone: "(213) 705-4006",
      //   SecondaryPhone: "(310) 456-8785",
      //   "Case Number": "0203",
      //   Client_ID: "236"
      // },
      // {
      //   FirstName: "Lisette",
      //   LastName: "Larkins",
      //   "Mailing Address": "20628 Rockcroft Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "lisette.larkins@aol.com",
      //   Phone: "(310) 430-0277",
      //   "Case Number": "0204",
      //   Client_ID: "237"
      // },
      // {
      //   FirstName: "Elina Tinai",
      //   LastName: "Kim",
      //   "Mailing Address": "20810 Las Flores Mesa Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "lisette.larkins@aol.com",
      //   Phone: "(310) 430-0277",
      //   "Case Number": "0205",
      //   Client_ID: "238"
      // },
      // {
      //   FirstName: "Cecilia",
      //   LastName: "Oliver",
      //   "Mailing Address": "20628 Rockcroft Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "lisette.larkins@aol.com",
      //   Phone: "(310) 430-0277",
      //   SecondaryPhone: "(310) 456-9070",
      //   "Case Number": "0206",
      //   Client_ID: "239"
      // },
      // {
      //   FirstName: "Monique",
      //   LastName: "Oliver",
      //   "Mailing Address": "20810 La Flores Mesa Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "MO90265@gmail.com",
      //   Phone: "(310) 409-5900",
      //   "Case Number": "0207",
      //   Client_ID: "240"
      // },
      // {
      //   FirstName: "David",
      //   LastName: "Dreier",
      //   "Mailing Address": "1185 Rexford Ave.",
      //   "Mailing City": "Pasadena",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91107",
      //   Email: "davidtdreier@gmail.com",
      //   Phone: "(310) 912-9191",
      //   "Case Number": "0003",
      //   Client_ID: "23"
      // },
      // {
      //   FirstName: "Nancy",
      //   LastName: "Levy",
      //   "Mailing Address": "4066 Calle Mira Monte",
      //   "Mailing City": "Newbury Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91380",
      //   Email: "nmlevy@icloud.com",
      //   "Secondary Email": "robinslevy@icloud.com",
      //   Phone: "(310) 869-7691",
      //   SecondaryPhone: "(310) 924-0197",
      //   "Case Number": "0004",
      //   Client_ID: "25"
      // },
      // {
      //   Client_ID: "26"
      // },
      // {
      //   FirstName: "Steven",
      //   LastName: "Siegel",
      //   "Mailing Address": "35100 Mulholland Hwy.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "jsiegel@smmusd.org",
      //   "Secondary Email": "stevesiegel@sbcglobal.net",
      //   Phone: "(310) 774-1601",
      //   SecondaryPhone: "(310) 505-4341",
      //   "Case Number": "0006",
      //   Client_ID: "27"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Garson",
      //   "Mailing Address": "5230 Carmento Drive",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91377",
      //   Email: "avantgarson@aol.com",
      //   "Secondary Email": "suzgarson@gmail.com",
      //   Phone: "(818) 439-7845",
      //   SecondaryPhone: "(818) 932-4802",
      //   "Case Number": "0005",
      //   Client_ID: "28"
      // },
      // {
      //   FirstName: "Cyndie",
      //   LastName: "Weinstock",
      //   "Mailing Address": "5304 Willow Ct. #608",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "cyndieweinstock@yahoo.com",
      //   Phone: "(310) 210-8486",
      //   "Case Number": "0009",
      //   Client_ID: "29"
      // },
      // {
      //   FirstName: "Christopher",
      //   LastName: "Carradine",
      //   "Mailing Address": "909 Mandalay Beach Rd.",
      //   "Mailing City": "Oxnard",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "93035",
      //   Email: "chris.carradine@icloud.com",
      //   "Secondary Email": "C.Carradine@mac.com",
      //   Phone: "(818) 359-4729",
      //   SecondaryPhone: "(310) 808-4644",
      //   "Case Number": "0007",
      //   Client_ID: "30"
      // },
      // {
      //   FirstName: "Gary",
      //   LastName: "Scott",
      //   "Mailing Address": "29500 Heathercliff Rd., #155",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "gsswillemdan@gmail.com",
      //   "Secondary Email": "gsswillemdan@mac.com",
      //   Phone: "(818) 216-2322",
      //   "Case Number": "0008",
      //   Client_ID: "31"
      // },
      // {
      //   FirstName: "Mitchel",
      //   LastName: "Jacobs",
      //   "Mailing Address": "4134 Maguire Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "mitch.jacobs@gmail.com",
      //   "Secondary Email": "tsykalo.tatyana@gmail.com",
      //   Phone: "(424) 634-1474",
      //   SecondaryPhone: "(424) 223-8558",
      //   "Case Number": "0010",
      //   Client_ID: "32"
      // },
      // {
      //   FirstName: "Neil",
      //   LastName: "Witt",
      //   "Mailing Address": "1320 E. Olympic Blvd.",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90021",
      //   Email: "neilwitt@hotmail.com",
      //   "Secondary Email": "LWitt123@gmail.com",
      //   Phone: "(213) 400-8516",
      //   SecondaryPhone: "(310) 489-2504",
      //   "Case Number": "0029",
      //   Client_ID: "33"
      // },
      // {
      //   FirstName: "Rodrick J.",
      //   LastName: "Ausmus",
      //   "Mailing Address": "3400 Encinal Canyon Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "juleyeausmus@msn.com",
      //   "Secondary Email": "ausmusrj@msn.com",
      //   Phone: "(310) 489-3307",
      //   SecondaryPhone: "(310) 924-5276",
      //   "Case Number": "0011",
      //   Client_ID: "34"
      // },
      // {
      //   FirstName: "Jonathan",
      //   LastName: "Banks",
      //   "Mailing Address": "3922 Rambla Orienta",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "Genara.banks@yahoo.com",
      //   "Secondary Email": "Baldbaby94@gmail.com",
      //   Phone: "(310) 924-9965",
      //   SecondaryPhone: "(310) 324-0033",
      //   "Case Number": "0026",
      //   Client_ID: "35"
      // },
      // {
      //   FirstName: "Diane",
      //   LastName: "Moss",
      //   "Mailing Address": "23708 Malibu Colony Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "todiane4@yahoo.com",
      //   "Secondary Email": "bankmatthias@yahoo.com",
      //   Phone: "(310) 463-1355",
      //   SecondaryPhone: "(310) 488-6700",
      //   "Case Number": "0027",
      //   Client_ID: "36"
      // },
      // {
      //   FirstName: "Anna",
      //   LastName: "Smith",
      //   "Mailing Address": "P.O. Box 789",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing Zip Code": "91301",
      //   Email: "annajis@gmail.com",
      //   Phone: "(805) 300-2722",
      //   "Case Number": "0028",
      //   Client_ID: "37"
      // },
      // {
      //   FirstName: "Gary",
      //   LastName: "Schrager",
      //   "Mailing Address": "3737 Oakfield Drive",
      //   "Mailing City": "Sherman Oaks",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91423",
      //   Email: "garyschrager1@aol.com",
      //   "Secondary Email": "franschrager@aol.com",
      //   Phone: "(310) 266-2246",
      //   SecondaryPhone: "(818) 802-0088",
      //   "Case Number": "0060",
      //   Client_ID: "38"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Omary",
      //   "Mailing Address": "32701 Mulholland Hwy",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "info@cleanwatertechnologies.net",
      //   "Secondary Email": "michael@wcmcco.com",
      //   Phone: "(310) 699-7117",
      //   SecondaryPhone: "(310) 745-4779",
      //   "Case Number": "0031",
      //   Client_ID: "39"
      // },
      // {
      //   FirstName: "Mitch",
      //   LastName: "Messinger",
      //   "Mailing Address": "9 Hitching Post Ln.",
      //   "Mailing City": "Bell Canyon",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91307",
      //   Email: "mthirdpower@sbcglobal.net",
      //   "Secondary Email": "deborah.a.jacoby@gmail.com",
      //   Phone: "(818) 601-6661",
      //   SecondaryPhone: "(818) 744-5698",
      //   "Case Number": "0030",
      //   Client_ID: "40"
      // },
      // {
      //   FirstName: "Kristin",
      //   LastName: "Blake",
      //   "Mailing Address": "PO Box 2874",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "cricket90265@gmail.com",
      //   Phone: "(310) 245-6998",
      //   "Case Number": "0012",
      //   Client_ID: "41"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Eilenberg",
      //   "Mailing Address": "11980 San Vicente Blvd., Suite 901",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90049",
      //   Email: "DDSMike@ymail.com",
      //   Phone: "(310) 488-1037",
      //   "Case Number": "0013",
      //   Client_ID: "42"
      // },
      // {
      //   FirstName: "John",
      //   LastName: "Gonzalez",
      //   "Mailing Address": "PO Box 6396",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "indigoonlatigo@msn.com",
      //   "Secondary Email": "dr.gpilot@hotmail.com",
      //   Phone: "(818) 970-7768",
      //   SecondaryPhone: "(310) 924-4754",
      //   "Case Number": "0014",
      //   Client_ID: "43"
      // },
      // {
      //   FirstName: "Manfred",
      //   LastName: "Heiting",
      //   "Mailing Address": "875 Comstock Ave., 18C",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90024",
      //   Email: "mh@heiting.org",
      //   Phone: "(310) 261-3750",
      //   "Case Number": "0032",
      //   Client_ID: "44"
      // },
      // {
      //   FirstName: "Jeff",
      //   LastName: "Jennings",
      //   "Mailing Address": "29500 Heathercliff Rd., Space 75",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "krisbjennings@gmail.com",
      //   "Secondary Email": "jdjenningslaw@gmail.com",
      //   Phone: "(310) 804-8071",
      //   SecondaryPhone: "(310) 266-3055",
      //   "Case Number": "0015",
      //   Client_ID: "45"
      // },
      // {
      //   FirstName: "Tony",
      //   LastName: "Lafer",
      //   "Mailing Address": "P.O. Box 6183",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "tonylafer@yahoo.com",
      //   "Secondary Email": "lena11282018@outlook.com",
      //   Phone: "(310) 405-1302",
      //   SecondaryPhone: "(310) 467-0838",
      //   "Case Number": "0016",
      //   Client_ID: "46"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Moore",
      //   "Mailing Address": "6215 Kanan Dume Road",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "moore808@outlook.com",
      //   "Secondary Email": "dna_moore@outlook.com",
      //   Phone: "(808) 430-9646",
      //   SecondaryPhone: "(310) 339-7134",
      //   "Case Number": "0017",
      //   Client_ID: "47"
      // },
      // {
      //   FirstName: "Linda",
      //   LastName: "Nicholas",
      //   "Mailing Address": "29759 Cuthbert Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "corahunt@yahoo.com",
      //   Phone: "(310) 567-8568",
      //   SecondaryPhone: "(310) 457-0587",
      //   "Case Number": "0018",
      //   Client_ID: "48"
      // },
      // {
      //   FirstName: "Scot",
      //   LastName: "Taylor",
      //   "Mailing Address": "P.O. Box 521",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "shannoncolburn@gmail.com",
      //   "Secondary Email": "dreamaker4uproductions@gmail.com",
      //   Phone: "(310) 613-1117",
      //   SecondaryPhone: "(310) 924-9589",
      //   "Case Number": "0044",
      //   Client_ID: "49"
      // },
      // {
      //   FirstName: "Karen",
      //   LastName: "Schoen",
      //   "Mailing Address": "28932 West Beach Ln.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "kareneschoen@gmail.com",
      //   "Secondary Email": "kbcanter@aol.com",
      //   Phone: "(917) 881-9808",
      //   SecondaryPhone: "(818) 590-2130",
      //   "Case Number": "0050",
      //   Client_ID: "50"
      // },
      // {
      //   FirstName: "David",
      //   LastName: "Schmickel",
      //   "Mailing Address": "27214 Baileys Neck Road",
      //   "Mailing City": "Easton",
      //   "Mailing State": "MD",
      //   "Mailing Zip Code": "21601",
      //   Email: "schmickelfamily@gmail.com",
      //   "Secondary Email": "dschmickel@foxkiser.com",
      //   Phone: "(202) 569-9810",
      //   SecondaryPhone: "(443) 858-5343",
      //   "Case Number": "0033",
      //   Client_ID: "51"
      // },
      // {
      //   FirstName: "Roger",
      //   LastName: "Pennell",
      //   "Mailing Address": "4789 Latigo Canyon Road",
      //   "Mailing City": "Malibu",
      //   "Mailing Zip Code": "90265",
      //   Email: "natasha@honanworld.com",
      //   "Secondary Email": "ripennell@gmail.com",
      //   Phone: "(310) 594-2635",
      //   SecondaryPhone: "(310) 457-4964",
      //   "Case Number": "0039",
      //   Client_ID: "53"
      // },
      // {
      //   FirstName: "Robert",
      //   LastName: "Tobin",
      //   "Mailing Address": "32786 Willow Bay Road",
      //   "Mailing City": "Wildomar",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "92595",
      //   Email: "Leslie Coogan (buldc3@gmail.com)",
      //   "Secondary Email": "scripts90@gmail.com",
      //   Phone: "(714) 717-5263",
      //   SecondaryPhone: "(714) 717-4289",
      //   "Case Number": "0045",
      //   Client_ID: "54"
      // },
      // {
      //   FirstName: "Larry",
      //   LastName: "Stokesberry",
      //   "Mailing Address": "32727 Vista de los Ondas",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "lstokesberry@verizon.net",
      //   "Secondary Email": "nstokesberry@verizon.net",
      //   Phone: "(310) 457-0040",
      //   SecondaryPhone: "(310) 457-4220",
      //   "Case Number": "0042",
      //   Client_ID: "55"
      // },
      // {
      //   FirstName: "Henry",
      //   LastName: "Schmidt",
      //   "Mailing Address": "7500 Capistrano Ave.",
      //   "Mailing City": "West Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91307",
      //   Email: "maaerickson@gmail.com",
      //   "Secondary Email": "henry.schmidt824@gmail.com",
      //   Phone: "(360) 918-6747",
      //   SecondaryPhone: "(323) 828-7137",
      //   "Case Number": "0041",
      //   Client_ID: "56"
      // },
      // {
      //   FirstName: "Sheri",
      //   LastName: "Swist",
      //   "Mailing Address": "23931 DeVille Way",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "sheripianoski@gmail.com",
      //   Phone: "(310) 869-5153",
      //   "Case Number": "0043",
      //   Client_ID: "57"
      // },
      // {
      //   FirstName: "Eugene Donald",
      //   LastName: "Michael",
      //   "Mailing Address": "279 Vera Canyon Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "edm@malibuonline.com",
      //   Phone: "(310) 463-1946",
      //   "Case Number": "0038",
      //   Client_ID: "58"
      // },
      // {
      //   FirstName: "Duane",
      //   LastName: "Burright, Jr.",
      //   "Mailing Address": "15317 Village 15",
      //   "Mailing City": "Camarillo",
      //   "Mailing Zip Code": "93012",
      //   Email: "Duane_Burright@yahoo.com",
      //   "Secondary Email": "Burr_64Elley@yahoo.com",
      //   Phone: "(805) 208-1012",
      //   SecondaryPhone: "(310) 339-5117",
      //   "Case Number": "0036",
      //   Client_ID: "59"
      // },
      // {
      //   FirstName: "Charlene",
      //   LastName: "Anderson",
      //   "Mailing Address": "33267 Decker School Rd",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "shugntess@verizon.net",
      //   Phone: "(310) 457-1754",
      //   SecondaryPhone: "(310) 457-1754",
      //   "Case Number": "0035",
      //   Client_ID: "60"
      // },
      // {
      //   FirstName: "Elias",
      //   LastName: "Davis",
      //   "Mailing Address": "740 Superba Ave",
      //   "Mailing City": "Venica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90291",
      //   Email: "elias.davis@gmail.com",
      //   "Secondary Email": "gailblock@gmail.com",
      //   Phone: "(310) 804-0324",
      //   SecondaryPhone: "(310) 804-0314",
      //   "Case Number": "0037",
      //   Client_ID: "61"
      // },
      // {
      //   FirstName: "Loretta",
      //   LastName: "Hicks",
      //   Email: "jdvir@financialpointe.com",
      //   "Secondary Email": "hokunights@gmail.com",
      //   SecondaryPhone: "(818) 621-4184",
      //   "Case Number": "0047",
      //   Client_ID: "62"
      // },
      // {
      //   FirstName: "Corey",
      //   LastName: "Larsen",
      //   "Mailing Address": "30745 Pacific Coast Hwy. #417",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "coreymoto2@gmaill.com",
      //   "Secondary Email": "danusianl@gmail.com",
      //   Phone: "(310) 874-0440",
      //   SecondaryPhone: "(310) 457-1930",
      //   "Case Number": "0048",
      //   Client_ID: "63"
      // },
      // {
      //   FirstName: "Raymond",
      //   LastName: "Prugh",
      //   "Mailing Address": "30473 Mulholland Hwy. #48",
      //   "Mailing City": "Agoura",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "prughizzy48@gmail.com",
      //   Phone: "(818) 726-5709",
      //   SecondaryPhone: "(818) 268-0741",
      //   "Case Number": "0049",
      //   Client_ID: "64"
      // },
      // {
      //   FirstName: "Anthony",
      //   LastName: "Deneri",
      //   "Mailing Address": "1 Hitching Post Lane",
      //   "Mailing City": "Bell Canyon",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91307",
      //   Email: "ldeneri@gmail.com",
      //   "Secondary Email": "deneri1@ca.rr.com",
      //   Phone: "(562) 335-3873",
      //   SecondaryPhone: "(562) 335-3846",
      //   "Case Number": "0046",
      //   Client_ID: "65"
      // },
      // {
      //   FirstName: "Cathy",
      //   LastName: "Wood",
      //   "Mailing Address": "6475 Zuma View Place 132",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "cec2ccw@verizon.net",
      //   Phone: "(310) 457-0744",
      //   "Case Number": "0096",
      //   Client_ID: "66"
      // },
      // {
      //   FirstName: "Davis",
      //   LastName: "Watson",
      //   "Mailing Address": "21323 Colina Drive",
      //   "Mailing City": "Topanga",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90290",
      //   Email: "daviscwatson@gmail.com",
      //   Phone: "(219) 910-3451",
      //   "Case Number": "0094",
      //   Client_ID: "67"
      // },
      // {
      //   FirstName: "Kristine",
      //   LastName: "Stewart",
      //   "Mailing Address": "5731 Calpine Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "L84krisms@msn.com",
      //   Phone: "(310) 435-3760",
      //   SecondaryPhone: "(310) 457-4370",
      //   "Case Number": "0092",
      //   Client_ID: "68"
      // },
      // {
      //   FirstName: "Christopher",
      //   LastName: "Shumow",
      //   "Mailing Address": "P.O. Box 6293",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90264",
      //   Email: "cshumow@visionsteen.com;  cshumow@aol.com",
      //   "Secondary Email": "aepcrown@me.com",
      //   Phone: "(310) 430-9991",
      //   SecondaryPhone: "(310) 430-3018",
      //   "Case Number": "0073",
      //   Client_ID: "69"
      // },
      // {
      //   FirstName: "Nicole",
      //   LastName: "Radoumis",
      //   "Mailing Address": "6441 Chesebro Rd.",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "nradoumis@gmail.com",
      //   Phone: "(310) 780-4177",
      //   "Case Number": "0090",
      //   Client_ID: "70"
      // },
      // {
      //   FirstName: "Benjamin",
      //   LastName: "Pollack",
      //   "Mailing Address": "3602 Forest Gate Circle",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "benjamin@tmg-la.com",
      //   "Secondary Email": "kelly@tmg-la.com",
      //   Phone: "(310) 767-6201",
      //   SecondaryPhone: "(310) 890-2011",
      //   "Case Number": "0058",
      //   Client_ID: "71"
      // },
      // {
      //   FirstName: "Leo",
      //   LastName: "Orr",
      //   "Mailing Address": "1589 Calle Del Estribo",
      //   "Mailing City": "Pacific Palisades",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90272",
      //   Email: "lignite1245@yahoo.com",
      //   "Secondary Email": "estribo7791@gmail.com",
      //   Phone: "(213) 300-3435",
      //   SecondaryPhone: "(213) 840-1964",
      //   "Case Number": "0065",
      //   Client_ID: "72"
      // },
      // {
      //   FirstName: "Lynn Anthony L. A.",
      //   LastName: "Marzulli",
      //   "Mailing Address": "24 Kimberwick Cr",
      //   "Mailing City": "Edmond",
      //   "Mailing State": "OK",
      //   "Mailing Zip Code": "73034",
      //   Email: "la@lamarzulli.net",
      //   "Secondary Email": "momfactor@aol.com",
      //   Phone: "(310) 721-3075",
      //   SecondaryPhone: "(310) 804-7475",
      //   "Case Number": "0055",
      //   Client_ID: "73"
      // },
      // {
      //   FirstName: "Patrick",
      //   LastName: "James",
      //   "Case Number": "0084",
      //   Client_ID: "74"
      // },
      // {
      //   FirstName: "Glenn",
      //   LastName: "Howe",
      //   "Mailing Address": "3909 Glenridge Drive",
      //   "Mailing City": "Sherman Oaks",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91423",
      //   Email: "lorax2013@aol.com",
      //   Phone: "(323) 229-6026",
      //   "Case Number": "0063",
      //   Client_ID: "75"
      // },
      // {
      //   FirstName: "Nancy",
      //   LastName: "Hill",
      //   "Mailing Address": "18375 Ventura Blvd #771",
      //   "Mailing City": "Tarzana",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91356",
      //   Email: "enchanted424@gmail.com",
      //   Phone: "(858) 888-0402",
      //   "Case Number": "0091",
      //   Client_ID: "76"
      // },
      // {
      //   FirstName: "Melanie",
      //   LastName: "Goudzwaard",
      //   "Mailing Address": "31528 Broad Beach Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "melanieg@financialseminars.com",
      //   "Secondary Email": "maurice@financialseminars.com",
      //   Phone: "(310) 774-1579",
      //   SecondaryPhone: "(310) 774-1580",
      //   "Case Number": "0082",
      //   Client_ID: "77"
      // },
      // {
      //   FirstName: "Isobel",
      //   LastName: "Gardner",
      //   "Mailing Address": "1515 7th Street, 278",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90401",
      //   Email: "isobelgardnerlmft@gmail.com",
      //   "Secondary Email": "",
      //   Phone: "(310) 980-6306",
      //   "Case Number": "0081",
      //   Client_ID: "78"
      // },
      // {
      //   FirstName: "Jeremy",
      //   LastName: "Lurey",
      //   "Mailing Address": "24606 Plover Way",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90256",
      //   Email: "jslurey@gmail.com",
      //   "Secondary Email": "monica.lurey@gmail.com",
      //   Phone: "(310) 570-8018",
      //   SecondaryPhone: "(310) 925-4725",
      //   "Case Number": "0086",
      //   Client_ID: "79"
      // },
      // {
      //   FirstName: "Dave",
      //   LastName: "Teel",
      //   "Mailing Address": "3601 Vista Pacific #11",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "art@nicolefisher.me",
      //   "Secondary Email": "dave@teelphato.com",
      //   Phone: "(310) 903-3543",
      //   SecondaryPhone: "(310) 903-3993",
      //   "Case Number": "0093",
      //   Client_ID: "80"
      // },
      // {
      //   FirstName: "Doug",
      //   LastName: "Sandler",
      //   "Mailing Address": "1705 Ocean Ave #509",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90401",
      //   Email: "dks@earthlink.net",
      //   "Secondary Email": "22girl@earthlink.net",
      //   Phone: "(310) 908-3838",
      //   SecondaryPhone: "(310) 266-6886",
      //   "Case Number": "0071",
      //   Client_ID: "81"
      // },
      // {
      //   FirstName: "John",
      //   LastName: "Ferry",
      //   "Mailing Address": "5640 Bush Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "jcf@balihai.com",
      //   "Secondary Email": "corkicorki@mac.com",
      //   Phone: "(808) 652-8900",
      //   SecondaryPhone: "(310) 890-4444",
      //   "Case Number": "0080",
      //   Client_ID: "82"
      // },
      // {
      //   FirstName: "Jamie",
      //   LastName: "Ottilie",
      //   "Mailing Address": "23679 Calabasas Rd. #756",
      //   "Mailing City": "Calabasas",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91302",
      //   Email: "ottiliej@gmail.com",
      //   "Secondary Email": "maryotl123@gmail.com",
      //   Phone: "(310) 589-9456",
      //   SecondaryPhone: "(310) 924-1109",
      //   "Case Number": "0089",
      //   Client_ID: "83"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Robinson",
      //   "Mailing Address": "29500 Heathercliff Rd. Unit #279",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "Billrmalibu09@gmail.com",
      //   Phone: "(310) 579-5867",
      //   SecondaryPhone: "(310) 924-5496",
      //   "Case Number": "0059",
      //   Client_ID: "84"
      // },
      // {
      //   FirstName: "Soba Cheviot Hills LLC",
      //   Email: "Greg@sobarecovery.com",
      //   Phone: "(310) 924-2053",
      //   "Case Number": "0021",
      //   Client_ID: "85"
      // },
      // {
      //   FirstName: "James",
      //   LastName: "Collins",
      //   "Mailing Address": "30473 Mulholland Hwy #157",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "30473MulhollandHWY@gmail.com",
      //   Phone: "(805) 350-1728",
      //   "Case Number": "0074",
      //   Client_ID: "86"
      // },
      // {
      //   FirstName: "Socorro",
      //   LastName: "Garcia",
      //   "Mailing Address": "2305 E. Ball Road #311",
      //   "Mailing City": "Anaheim",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "92806",
      //   Email: "socorro4homes@yahoo.com",
      //   "Secondary Email": "coco4homes@gmail.com",
      //   Phone: "(424) 395-6672",
      //   "Case Number": "0075",
      //   Client_ID: "87"
      // },
      // {
      //   FirstName: "Sybil",
      //   LastName: "Davis",
      //   "Mailing Address": "3239 Ledgewood Dr",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90068",
      //   Email: "sybiladavis@aol.com",
      //   "Secondary Email": "thomasyotka@aol.com",
      //   Phone: "(818) 422-8156",
      //   SecondaryPhone: "(818) 425-8901",
      //   "Case Number": "0034",
      //   Client_ID: "88"
      // },
      // {
      //   FirstName: "Casey",
      //   LastName: "Schlefstein",
      //   "Mailing Address": "P.O. Box 4408",
      //   "Mailing City": "Thousand Oaks",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91359",
      //   Email: "casey@schlefstein.com",
      //   "Secondary Email": "jellonel@yahoo.com",
      //   Phone: "(818) 389-6460",
      //   SecondaryPhone: "(818) 389-0997",
      //   "Case Number": "0078",
      //   Client_ID: "89"
      // },
      // {
      //   FirstName: "Matthew",
      //   LastName: "Reid",
      //   "Mailing Address": "28830 Hampton Place",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "matthew_j_reid@yahoo.com",
      //   "Secondary Email": "mjtruelson@yahoo.com",
      //   Phone: "(202) 812-2715",
      //   SecondaryPhone: "(503) 819-6662",
      //   "Case Number": "0019",
      //   Client_ID: "90"
      // },
      // {
      //   FirstName: "Gary",
      //   LastName: "Zethraeus",
      //   "Mailing Address": "4490 Encinal Canyon Road",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "z@malibuvacation.net",
      //   "Secondary Email": "karen@malibuvacation.net",
      //   Phone: "(310) 403-5103",
      //   "Case Number": "0025",
      //   Client_ID: "91"
      // },
      // {
      //   FirstName: "Douglas",
      //   LastName: "Richardson",
      //   "Mailing Address": "9705 Owensmouth Ave #2",
      //   "Mailing City": "Chatsworth",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91311",
      //   Email: "doug937@gmail.com",
      //   Phone: "(310) 457-6400",
      //   "Case Number": "0070",
      //   Client_ID: "92"
      // },
      // {
      //   FirstName: "Burt",
      //   LastName: "Ross",
      //   "Mailing Address": "P.O. Box 340",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "burtrossrealty@gmail.com",
      //   "Secondary Email": "joanr1000@aol.com",
      //   Phone: "(201) 281-6642",
      //   SecondaryPhone: "(201) 486-0864",
      //   "Case Number": "0020",
      //   Client_ID: "93"
      // },
      // {
      //   FirstName: "Oona",
      //   LastName: "Khan",
      //   "Mailing Address": "24544 Vantage Point Terrace",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "oonakhan@gmail.com",
      //   Phone: "(310) 633-0671",
      //   "Case Number": "0085",
      //   Client_ID: "94"
      // },
      // {
      //   FirstName: "David",
      //   LastName: "Domm",
      //   "Mailing Address": "5737 Kanan RD. #504",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "david@livinginthepause.com",
      //   Phone: "(818) 318-0234",
      //   "Case Number": "0062",
      //   Client_ID: "95"
      // },
      // {
      //   FirstName: "Vicki",
      //   LastName: "Christian",
      //   "Mailing Address": "P.O. Box #6823",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90264",
      //   Email: "vickidchristian@gmail.com",
      //   "Secondary Email": "tinacschwartz@gmail.com",
      //   Phone: "(818) 851-9002",
      //   SecondaryPhone: "(818) 879-1745",
      //   "Case Number": "0064",
      //   Client_ID: "96"
      // },
      // {
      //   FirstName: "Garbis",
      //   LastName: "Bedoyan",
      //   "Mailing Address": "30473 Mulholland Hwy. #18",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "garbedo@icloud.com",
      //   Phone: "(310) 704-4353",
      //   "Case Number": "0061",
      //   Client_ID: "97"
      // },
      // {
      //   FirstName: "Shannon",
      //   LastName: "Ggem",
      //   Email: "shannonggem@gmail.com",
      //   "Secondary Email": "andyggem@icloud.com",
      //   Phone: "(213) 999-9907",
      //   "Case Number": "0068",
      //   Client_ID: "98"
      // },
      // {
      //   FirstName: "Beatrice",
      //   LastName: "Jordan",
      //   "Mailing Address": "2025 Ocean Drive",
      //   "Mailing City": "Oxnard",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "93035",
      //   Email: "bibijordan@gmail.com",
      //   "Secondary Email": "fire2018@herrschultz.com",
      //   Phone: "(310) 457-2088",
      //   SecondaryPhone: "(310) 457-7085",
      //   "Case Number": "0069",
      //   Client_ID: "99"
      // },
      // {
      //   FirstName: "Bruce",
      //   LastName: "Shultz",
      //   "Mailing Address": "2025 Ocean Drive",
      //   "Mailing City": "Oxnard",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "93035",
      //   Email: "fire2018@herrschultz.com",
      //   "Secondary Email": "herrschultz2019@gmail.com",
      //   Phone: "(310) 457-7085",
      //   "Case Number": "0072",
      //   Client_ID: "100"
      // },
      // {
      //   FirstName: "Stacy",
      //   LastName: "Clunies-Ross",
      //   Email: "malibutinkerbell@gmail.com",
      //   Phone: "(310) 924-4740",
      //   "Case Number": "0067",
      //   Client_ID: "101"
      // },
      // {
      //   FirstName: "Chantal",
      //   LastName: "Gillberg",
      //   "Mailing Address": "23838 Pacific Coast Hwy., #211",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "chantal@gillbergdesign.com",
      //   Phone: "(310) 457-1768",
      //   "Case Number": "0076",
      //   Client_ID: "102"
      // },
      // {
      //   FirstName: "Richard Wayne",
      //   LastName: "Corman",
      //   "Mailing Address": "6729 Dume Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "dikkybird@mac.com",
      //   Phone: "(310) 457-7524",
      //   "Case Number": "0097",
      //   Client_ID: "103"
      // },
      // {
      //   FirstName: "Richard Walter",
      //   LastName: "Corman Jr.",
      //   "Mailing Address": "6729 Dume Dr.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "cosmohighwire@gmail.com",
      //   Phone: "(808) 631-9311",
      //   SecondaryPhone: "(310) 457-7524",
      //   "Case Number": "0098",
      //   Client_ID: "104"
      // },
      // {
      //   FirstName: "Croft",
      //   LastName: "Deborah",
      //   "Mailing Address": "5370 Oak Park Lane Apt #185",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "debicroft@gmail.com",
      //   Phone: "(805) 428-1040",
      //   "Case Number": "0099",
      //   Client_ID: "105"
      // },
      // {
      //   FirstName: "Allana",
      //   LastName: "Haradyn",
      //   "Mailing Address": "P.O. Box 1122",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91376",
      //   Email: "allharadyn@gmail.com",
      //   Phone: "(310) 951-7467",
      //   "Case Number": "0100",
      //   Client_ID: "106"
      // },
      // {
      //   FirstName: "Brad",
      //   LastName: "Howe",
      //   "Mailing Address": "947 6th Street #6",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90403",
      //   Email: "brad@bradhowe.com",
      //   "Secondary Email": "alicemhowe@gmail.com",
      //   Phone: "(818) 519-6035",
      //   SecondaryPhone: "(310) 463-2349",
      //   "Case Number": "0101",
      //   Client_ID: "107"
      // },
      // {
      //   FirstName: "Robert",
      //   LastName: "Hummer",
      //   "Mailing Address": "1865 Greenfield ave #103",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90025",
      //   Email: "hum14@live.com",
      //   "Secondary Email": "hummerdawn620@gmail.com",
      //   Phone: "(310) 463-8244",
      //   "Case Number": "0102",
      //   Client_ID: "108"
      // },
      // {
      //   FirstName: "Richard",
      //   LastName: "Kingery",
      //   "Mailing Address": "7912 Marquard Ave.",
      //   "Mailing City": "Canoga Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91304",
      //   Email: "rgkingery@yahoo.com",
      //   "Secondary Email": "mrfixit.2005@yahoo.com",
      //   Phone: "(310) 435-3326",
      //   SecondaryPhone: "(310) 487-7351",
      //   "Case Number": "0103",
      //   Client_ID: "109"
      // },
      // {
      //   FirstName: "Tommy",
      //   LastName: "Knapp",
      //   "Mailing Address": "601 Via de la Paz",
      //   "Mailing City": "Pacific Palasades",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90272",
      //   Email: "brookviewranch@gmail.com",
      //   "Secondary Email": "brookviewranch@gmail.com",
      //   Phone: "(310) 968-8275",
      //   SecondaryPhone: "(310) 570-6313",
      //   "Case Number": "0104",
      //   Client_ID: "110"
      // },
      // {
      //   FirstName: "Merrill",
      //   LastName: "Miller",
      //   "Mailing Address": "30473 Mulholland Hwy., SPC 31",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Phone: "(818) 585-7988",
      //   SecondaryPhone: "(818) 585-3458",
      //   "Case Number": "0105",
      //   Client_ID: "111"
      // },
      // {
      //   FirstName: "Kalikolehua",
      //   LastName: "Orian",
      //   "Mailing Address": "5613 Foxwood Apt E",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91377",
      //   Email: "kaliko.orian@gmail.com",
      //   Phone: "(310) 460-9951",
      //   "Case Number": "0088",
      //   Client_ID: "112"
      // },
      // {
      //   FirstName: "Lisajo",
      //   LastName: "McGee",
      //   "Mailing Address": "P.O. Box #2505",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "1lisajomcgee@gmail.com",
      //   Phone: "(310) 457-5173",
      //   SecondaryPhone: "(310) 738-9926",
      //   "Case Number": "0087",
      //   Client_ID: "113"
      // },
      // {
      //   FirstName: "Jena",
      //   LastName: "Weiss",
      //   "Mailing Address": "27434 Rondell St.",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "capdogct@yahoo.com",
      //   Phone: "(310) 919-6363",
      //   "Case Number": "0095",
      //   Client_ID: "114"
      // },
      // {
      //   FirstName: "Dana",
      //   LastName: "Shepard-Nineberg",
      //   "Mailing Address": "1890 W Hillcrest Dr. #465",
      //   "Mailing City": "Newbury Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91320",
      //   Email: "danasheparddn@gmail.com",
      //   "Secondary Email": "mnineberg@greatbignoise.com",
      //   Phone: "(818) 519-5543",
      //   SecondaryPhone: "(818) 292-5123",
      //   "Case Number": "0106",
      //   Client_ID: "115"
      // },
      // {
      //   FirstName: "Elizabeth",
      //   LastName: "Walsh",
      //   "Mailing Address": "30473 Mulholland Hwy. #22",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "bettynpyreness@gmail.com",
      //   Phone: "(818) 865-1810",
      //   SecondaryPhone: "(818) 309-3003",
      //   "Case Number": "0118",
      //   Client_ID: "116"
      // },
      // {
      //   FirstName: "Anthony",
      //   LastName: "Walczuk",
      //   "Mailing Address": "5537 Round Meadow Rd.",
      //   "Mailing City": "Hidden Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91302",
      //   Email: "twmalibu@hotmail.com",
      //   "Secondary Email": "dana@shirleyofhollywood.com",
      //   Phone: "(310) 678-9408",
      //   "Case Number": "0117",
      //   Client_ID: "117"
      // },
      // {
      //   FirstName: "Jonnie",
      //   LastName: "Turnure",
      //   "Mailing Address": "30473 Mulholland Hwy. #34",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "jonnieturnure@yahoo.com",
      //   Phone: "(818) 889-6122",
      //   "Case Number": "0116",
      //   Client_ID: "118"
      // },
      // {
      //   FirstName: "Frank",
      //   LastName: "Thomas",
      //   "Mailing Address": "5815 Hickory Dr. #H",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91377",
      //   Email: "fmthomas4@gmail.com",
      //   "Secondary Email": "malibupartyrents@gmail.com",
      //   Phone: "(310) 617-4170",
      //   SecondaryPhone: "(310) 913-4133",
      //   "Case Number": "0115",
      //   Client_ID: "119"
      // },
      // {
      //   FirstName: "Joel",
      //   LastName: "Stein",
      //   "Mailing Address": "1652 Cross Bridge Place",
      //   "Mailing City": "Thousand Oaks",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91362",
      //   Email: "artbass@aol.com",
      //   "Secondary Email": "joesteinwurzel@yahoo.com",
      //   Phone: "(818) 720-6395",
      //   "Case Number": "0113",
      //   Client_ID: "120"
      // },
      // {
      //   FirstName: "Raymond",
      //   LastName: "Sheehan Jr. (DECEASED)",
      //   "Mailing Address": "30473 Mulholland Hwy. #87",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "raybo117@gmail.com",
      //   "Secondary Email": "raybo117@gmail.com",
      //   Phone: "(310) 487-0934",
      //   "Case Number": "0112",
      //   Client_ID: "121"
      // },
      // {
      //   FirstName: "Pamela",
      //   LastName: "Robins",
      //   "Mailing Address": "6048 Fairview Place",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "pamela.a.robins@gmail.com",
      //   Phone: "(424) 235-9792",
      //   "Case Number": "0109",
      //   Client_ID: "122"
      // },
      // {
      //   FirstName: "Karen",
      //   LastName: "Schultz",
      //   "Mailing Address": "30473 Mulholland Hwy. #19",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "karenjs13@outlook.com",
      //   Phone: "(805) 905-1898",
      //   "Case Number": "0111",
      //   Client_ID: "123"
      // },
      // {
      //   FirstName: "Dominick",
      //   LastName: "Oliveri",
      //   "Mailing Address": "33360 Decker School Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "mrmalibu@mr-malibu.com",
      //   Phone: "(310) 457-4732",
      //   "Case Number": "0107",
      //   Client_ID: "124"
      // },
      // {
      //   FirstName: "Becky",
      //   LastName: "Christensen",
      //   "Mailing Address": "30473 Mulholland Hwy, #87",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "bchristensen@courtbizsolution.com",
      //   "Secondary Email": "bvchristensen@gmail.com",
      //   Phone: "(747) 230-7319",
      //   "Case Number": "0079",
      //   Client_ID: "125"
      // },
      // {
      //   FirstName: "Vicki",
      //   LastName: "Laken",
      //   Email: "vlaken44@gmail.com",
      //   "Secondary Email": "marissaalix@gmail.com",
      //   "Case Number": "0054",
      //   Client_ID: "126"
      // },
      // {
      //   FirstName: "Blase",
      //   LastName: "Dillingham",
      //   "Mailing Address": "374 East Rustic Rd.",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90402",
      //   Email: "bdillingham@manatt.com",
      //   "Secondary Email": "susansdillingham@gmail.com",
      //   Phone: "(310) 308-3252",
      //   SecondaryPhone: "(310) 918-1505",
      //   "Case Number": "0051",
      //   Client_ID: "127"
      // },
      // {
      //   FirstName: "Amir",
      //   LastName: "Heshmatpour",
      //   "Mailing Address": "6363 Lunita Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "amirhesh@me.com",
      //   "Secondary Email": "kheshmatpour@me.com",
      //   Phone: "(310) 721-4391",
      //   "Case Number": "0083",
      //   Client_ID: "128"
      // },
      // {
      //   FirstName: "Stephen",
      //   LastName: "Hoyt",
      //   "Mailing Address": "4652 Arriba Drive",
      //   "Mailing City": "Tarzana",
      //   "Mailing Zip Code": "91356",
      //   Email: "carolhoyt@mac.com",
      //   Phone: "(310) 963-2345",
      //   "Case Number": "0052",
      //   Client_ID: "129"
      // },
      // {
      //   FirstName: "Deborah",
      //   LastName: "Croft",
      //   "Mailing Address": "5370 Oak Park Lane Apt 185",
      //   "Mailing City": "Oak Park",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91377",
      //   Email: "debicroft@gmail.com",
      //   Phone: "(805) 428-1040",
      //   "Case Number": "0099",
      //   Client_ID: "130"
      // },
      // {
      //   Client_ID: "131"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Howe",
      //   "Mailing Address": "947 6th Street, Unit G",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90403",
      //   Email: "brad@bradhowe.com",
      //   "Secondary Email": "alex@bradhowe.com",
      //   Phone: "(818) 519-6035",
      //   SecondaryPhone: "(310) 600-6857",
      //   "Case Number": "0101",
      //   Client_ID: "132"
      // },
      // {
      //   FirstName: "Laura",
      //   LastName: "Kotimaki-Hurd",
      //   "Mailing Address": "6717 Portshead Road",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "lkhequestrian@gmail.com",
      //   "Secondary Email": "sahmalibu@msn.com",
      //   Phone: "(310) 990-2772",
      //   SecondaryPhone: "(310) 924-2524",
      //   "Case Number": "0053",
      //   Client_ID: "133"
      // },
      // {
      //   FirstName: "Vicki",
      //   LastName: "Laken",
      //   "Mailing Address": "PO Box 1634",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91376",
      //   Email: "vlaken44@gmail.com",
      //   "Secondary Email": "marissaalix@gmail.com",
      //   Phone: "(310) 909-4030",
      //   SecondaryPhone: "(310) 270-0061",
      //   "Case Number": "0053",
      //   Client_ID: "134"
      // },
      // {
      //   FirstName: "Sienna",
      //   LastName: "Oliver",
      //   "Mailing Address": "20810 Las Flores Mesa Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "MO90265@gmail.com",
      //   Phone: "(310) 409-5900",
      //   "Case Number": "0207",
      //   Client_ID: "241"
      // },
      // {
      //   FirstName: "Paul",
      //   LastName: "Ferra",
      //   "Mailing Address": "101 S. Topanga Cyn. Blvd #1157",
      //   "Mailing City": "Topanga",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90290",
      //   Email: "pferra@coldwellbanker.com",
      //   "Secondary Email": "melissao@coldwellbanker.com",
      //   Phone: "(310) 455-1717",
      //   SecondaryPhone: "(310) 403-4455",
      //   "Case Number": "0209",
      //   Client_ID: "242"
      // },
      // {
      //   FirstName: "Wayne",
      //   LastName: "Spina",
      //   "Mailing Address": "22253 Pacific Coast Highway",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "spinasinc@gmail.com",
      //   Phone: "(310) 980-8220",
      //   SecondaryPhone: "(310) 254-4487",
      //   "Case Number": "0210",
      //   Client_ID: "243"
      // },
      // {
      //   FirstName: "Jeffrey",
      //   LastName: "Moskowitz",
      //   "Mailing Address": "201 S. Windsor",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90004",
      //   Email: "jefmosk@pacbell.net",
      //   "Secondary Email": "neppie@pacbell.net",
      //   Phone: "(323) 363-4460",
      //   SecondaryPhone: "(323) 363-4458",
      //   Client_ID: "244"
      // },
      // {
      //   FirstName: "Bronson",
      //   LastName: "Bard",
      //   "Mailing Address": "30431 Morning View Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "bronsonbard@gmail.com",
      //   Phone: "(310) 924-1606",
      //   "Case Number": "0214",
      //   Client_ID: "245"
      // },
      // {
      //   FirstName: "Steven",
      //   LastName: "Bard",
      //   "Mailing Address": "30431 Morning View Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "stevenbard@verizon.net",
      //   "Secondary Email": "yesquerrabard@hotmail.com",
      //   Phone: "(310) 924-9252",
      //   SecondaryPhone: "(310) 924-9255",
      //   "Case Number": "0213",
      //   Client_ID: "246"
      // },
      // {
      //   FirstName: "Jason Riddick",
      //   Email: "HOA@malibuwestbc.com",
      //   "Secondary Email": "jason_riddick@hotmail.com",
      //   Phone: "(310) 457-0195",
      //   "Case Number": "0212",
      //   Client_ID: "247"
      // },
      // {
      //   FirstName: "Jill",
      //   LastName: "Sandbach",
      //   "Mailing Address": "41000 Pacific Coast Highway",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "mboajill@gmail.com",
      //   Phone: "(310) 457-9271",
      //   "Case Number": "215",
      //   Client_ID: "248"
      // },
      // {
      //   FirstName: "Nancy",
      //   LastName: "Withrow",
      //   "Mailing Address": "7832 Kentwood Ave.",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90045",
      //   Email: "nwithrow3@gmail.com",
      //   Phone: "(310) 433-7682",
      //   "Case Number": "216",
      //   Client_ID: "249"
      // },
      // {
      //   FirstName: "Vance",
      //   LastName: "Meyer",
      //   "Mailing Address": "3747 Seahorn Drive",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "hstitch945@gmail.com",
      //   "Secondary Email": "pattilynnmeyer@gmail.com",
      //   Phone: "(310) 699-9112",
      //   SecondaryPhone: "(310) 459-2871",
      //   "Case Number": "217",
      //   Client_ID: "250"
      // },
      // {
      //   FirstName: "Steven",
      //   LastName: "Grahek",
      //   "Mailing Address": "6900 Grasswood Ave",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "stargzrstv@aol.com",
      //   "Secondary Email": "deborahlagk@mac.com",
      //   Phone: "(310) 924-9806",
      //   SecondaryPhone: "(310) 924-1321",
      //   "Case Number": "218",
      //   Client_ID: "251"
      // },
      // {
      //   FirstName: "George",
      //   LastName: "Kafrouni",
      //   "Mailing Address": "560 Starlight Crest Drive",
      //   "Mailing City": "La Canada",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91011",
      //   Email: "dkafrouni@verizon.net",
      //   "Secondary Email": "jkafrouni66@gmail.com",
      //   Phone: "(323) 646-4293",
      //   SecondaryPhone: "(503) 915-4849",
      //   "Case Number": "219",
      //   Client_ID: "252"
      // },
      // {
      //   FirstName: "Steve",
      //   LastName: "Kamins",
      //   "Mailing Address": "1327 Falling Star Ave.",
      //   "Mailing City": "Westlake Village",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91362",
      //   Email: "skkamins@gmail.com",
      //   Phone: "(805) 432-3688",
      //   "Case Number": "220",
      //   Client_ID: "253"
      // },
      // {
      //   FirstName: "Alex",
      //   LastName: "Quilici",
      //   "Mailing Address": "528 Palisades Drive",
      //   "Mailing City": "Palisades",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90272",
      //   Email: "malibualex@aol.com",
      //   "Secondary Email": "heymelissaq@aol.com",
      //   Phone: "(310) 346-1475",
      //   SecondaryPhone: "(310) 489-4663",
      //   "Case Number": "0221",
      //   Client_ID: "254"
      // },
      // {
      //   FirstName: "Myo",
      //   LastName: "Aung",
      //   "Mailing Address": "5900 Filaree Heights",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "myosterman@gmail.com",
      //   "Secondary Email": "hilsykes@gmail.com",
      //   Phone: "(818) 519-3498",
      //   SecondaryPhone: "(805) 758-5102",
      //   "Case Number": "0222",
      //   Client_ID: "255"
      // },
      // {
      //   FirstName: "Sarah",
      //   LastName: "Ryan",
      //   "Mailing Address": "26312 Fairside Rd.",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "tinbather@gmail.com",
      //   "Secondary Email": "seaninbowl@gmail.com",
      //   Phone: "(310) 913-4927",
      //   SecondaryPhone: "(949) 290-3573",
      //   "Case Number": "0223",
      //   Client_ID: "256"
      // },
      // {
      //   FirstName: "Hunter",
      //   LastName: "Patterson",
      //   "Mailing Address": "924 3rd Street",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90403",
      //   Email: "hunterpatterson@gmail.com",
      //   "Secondary Email": "charlottepatt@gmail.com",
      //   Phone: "(310) 383-7171",
      //   SecondaryPhone: "(310) 210-4975",
      //   Client_ID: "257"
      // },
      // {
      //   FirstName: "Emma",
      //   LastName: "Blackwood",
      //   "Mailing Address": "127 S. Meredith Ave. Apt. D",
      //   "Mailing City": "Pasadena",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91106",
      //   Email: "emmamarieblackwood@gmail.com",
      //   Phone: "(310) 980-0440",
      //   Client_ID: "258"
      // },
      // {
      //   Client_ID: "259"
      // },
      // {
      //   FirstName: "William",
      //   LastName: "Robinson",
      //   "Mailing Address": "31770 Cottontail Lane",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "billrmalibu09@gmail.com",
      //   "Secondary Email": "malibu5920@aol.com",
      //   Phone: "(310) 579-5867",
      //   SecondaryPhone: "(310) 924-5496",
      //   Client_ID: "260"
      // },
      // {
      //   FirstName: "Gary",
      //   LastName: "Wilstein",
      //   "Mailing Address": "4240 Avenida de la Encinal",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "gary@wilstein.net",
      //   "Secondary Email": "kew11870@gmail.com",
      //   Phone: "(310) 457-9005",
      //   SecondaryPhone: "(310) 457-9005",
      //   Client_ID: "261"
      // },
      // {
      //   FirstName: "Chad",
      //   LastName: "Brannon",
      //   "Mailing Address": "30765 Pacific Coast Highway Ste. #280",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "chad@chadbrannon.com",
      //   Phone: "(818) 692-5332",
      //   SecondaryPhone: "(818) 371-9619",
      //   Client_ID: "262"
      // },
      // {
      //   FirstName: "Julie",
      //   LastName: "Hart",
      //   "Mailing Address": "P.O. Box 456",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "91301",
      //   Email: "julieh3710@yahoo.com",
      //   Phone: "(310) 617-2174",
      //   "Case Number": "226",
      //   Client_ID: "263"
      // },
      // {
      //   FirstName: "Timothy",
      //   LastName: "Webb",
      //   "Mailing Address": "34135 Mulholland Hwy",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   "Secondary Email": "atwebb1@mac.com",
      //   Phone: "(310) 990-0910",
      //   SecondaryPhone: "(805) 230-1079",
      //   "Case Number": "227",
      //   Client_ID: "264"
      // },
      // {
      //   FirstName: "Julie",
      //   LastName: "Hart",
      //   "Mailing Address": "PO Box 456",
      //   "Mailing City": "Agoura Hills",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "julieh3710@yahoo.com",
      //   Phone: "(310) 617-2174",
      //   "Case Number": "226",
      //   Client_ID: "266"
      // },
      // {
      //   FirstName: "Emma",
      //   LastName: "Brisinger",
      //   "Mailing Address": "1133 25th Street Apt #8",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90403",
      //   Email: "emmabrisinger99@gmail.com",
      //   Phone: "(424) 395-8110",
      //   "Case Number": "81",
      //   Client_ID: "267"
      // },
      // {
      //   FirstName: "Alex",
      //   LastName: "Brisinger",
      //   "Mailing Address": "1133 25th Street",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90403",
      //   Email: "alexbrisinger@gmail.com",
      //   Phone: "(424) 395-8113",
      //   "Case Number": "81",
      //   Client_ID: "268"
      // },
      // {
      //   FirstName: "Anton",
      //   LastName: "Brisinger",
      //   "Mailing Address": "1133 2th Street",
      //   "Mailing City": "Santa Monica",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90403",
      //   Email: "antondillinger@gmail.com",
      //   Phone: "(310) 413-1518",
      //   "Case Number": "81",
      //   Client_ID: "269"
      // },
      // {
      //   FirstName: "James",
      //   LastName: "Collins",
      //   "Mailing Address": "30473 Mulholland Hwy #157",
      //   "Mailing City": "Cornell",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91301",
      //   Email: "30473mulhollandhwy@gmail.com",
      //   Phone: "(805) 350-1728",
      //   Client_ID: "270"
      // },
      // {
      //   Client_ID: "271"
      // },
      // {
      //   Client_ID: "272"
      // },
      // {
      //   Client_ID: "273"
      // },
      // {
      //   FirstName: "Victor",
      //   LastName: "Marmon",
      //   "Mailing Address": "P.O. Box 5835",
      //   "Mailing City": "Sherman Oaks",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "91413",
      //   Email: "vmarmon@outlook.com",
      //   "Secondary Email": "kbmarmon@gmail.com",
      //   Phone: "(310) 874-3729",
      //   SecondaryPhone: "(310) 994-0583",
      //   "Case Number": "229",
      //   Client_ID: "274"
      // },
      // {
      //   FirstName: "Mitchell",
      //   LastName: "Marmon",
      //   "Mailing Address": "1469 S. Canfield Ave. Apt #2",
      //   "Mailing City": "Los Angeles",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90035",
      //   Email: "mitchellmarmon@gmail.com",
      //   Phone: "(310) 773-1421",
      //   "Case Number": "230",
      //   Client_ID: "275"
      // },
      // {
      //   FirstName: "Christine",
      //   LastName: "Jackson",
      //   "Mailing Address": "P.O. Box 4264",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90264-4264",
      //   Email: "libraleolove@yahoo.com",
      //   Phone: "(310) 795-0601",
      //   "Case Number": "0231",
      //   Client_ID: "276"
      // },
      // {
      //   FirstName: "Heikki",
      //   LastName: "Ketola",
      //   "Mailing Address": "27162 Sea Vista",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "90265",
      //   Email: "heka@ketola.com",
      //   "Secondary Email": "gabbard@defgrp.com",
      //   Phone: "(310) 801-4848",
      //   SecondaryPhone: "(818) 519-3438",
      //   "Case Number": "232",
      //   Client_ID: "277"
      // },
      // {
      //   FirstName: "Barry Melvin",
      //   LastName: "Bakalor",
      //   Client_ID: "278"
      // },
      // {
      //   Client_ID: "279"
      // },
      // {
      //   FirstName: "Michael",
      //   LastName: "Dillingham",
      //   "Mailing Address": "295 Marina",
      //   "Mailing City": "San Francisco",
      //   "Mailing State": "CA",
      //   "Mailing Zip Code": "94123",
      //   Email: "michael.dillingham@gmail.com",
      //   Phone: "(650) 474-1034",
      //   "Case Number": "233",
      //   Client_ID: "280"
      // },
      // {
      //   FirstName: "Elizabeth",
      //   LastName: "Harrington",
      //   "Mailing Address": "42500 Pacific Coast Highway",
      //   "Mailing City": "Malibu",
      //   "Mailing State": "California",
      //   "Mailing Zip Code": "90265",
      //   Email: "eharringtonglobal@gmail.com",
      //   Phone: "(310) 860-1520",
      //   "Case Number": "228",
      //   Client_ID: "265"
      // }
    ]
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    }
    //   error() {
    //     return this.$store.getters.error;
    //   },
    //   loading() {
    //     return this.$store.getters.loading;
    //   }
  },
  watch: {
    // user(value) {
    //   if (value !== null && value !== undefined) {
    //     // this.$store.dispatch("loadMatters", value);
    //     console.log("user from login to /:", value);
    //     this.$router.replace("/");
    //   }
    // },
    // existingList(value) {
    //   //launch pricing for each item
    //   if (value.length > 0) {
    //     value.forEach(item => {
    //       if (item.DESCRIPTION && item.DESCRIPTION !== "") {
    //         let ref = Math.floor(Math.random() * 90000) + 10000;
    //         let cat = "";
    //         if (item.CATEGORY && item.CATEGORY !== "") {
    //           cat = item.CATEGORY.trim().toUpperCase();
    //         } else {
    //           cat = "Other";
    //         }
    //         let title = item.DESCRIPTION;
    //         title = title.replace(/-/g, " ");
    //         title = title.replace(/\//g, " ").trim();
    //         title = title.toLowerCase();
    //         if (cat && cat !== "Other") {
    //           title = cat.replace(/\//g, " ").toLowerCase() + " " + title;
    //         }
    //         let desc = "";
    //         if (item.NOTES && item.NOTES !== "") {
    //           desc = item.NOTES.toLowerCase()
    //             .replaceAll("-", " ")
    //             .replace(/\//g, " ")
    //             .trim();
    //         }
    //         let source = "";
    //         if (item.SOURCE && item.SOURCE !== "") {
    //           source = item.SOURCE.toLowerCase()
    //             .replaceAll("-", " ")
    //             .replaceAll("/", " ")
    //             .trim();
    //         }
    //         let searchTerms = slugify(title, {
    //           replacement: "+",
    //           remove: /[$*_+~.()'"!\-:@,#]/g,
    //           lower: true
    //         });
    //         let newItem = {
    //           title,
    //           ref,
    //           category: cat,
    //           userDescription: desc,
    //           comment: null,
    //           notes: item.NOTES,
    //           source,
    //           quantity: item.QTY,
    //           pricing: null
    //         };
    //         console.log(`launching pricing for: ${searchTerms}`, newItem);
    //       }
    //     });
    //   }
    // }
  },
  methods: {
    // uploadList(list) {
    //   //get the file
    //   //convert the file to json
    //   //create a list of objects
    //   //save the new user with the list of objects
    //   //run the list of objects through getPricing
    //   //wait for the results

    // },
    onFilePicked() {
      if (event.target.files) {
        this.loading = true;
        this.existingList = event.target.files[0];
        this.loading = false;

        console.log("loaded");
        // let jsa = XLSX.utils.sheet_to_json(this.existingList);
        console.log("result json");
        // console.log(jsa);
        let reader = new FileReader();
        reader.readAsBinaryString(this.existingList);
        reader.onload = () => {
          let data = reader.result;
          let workbook = XLSX.read(data, { type: "binary" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];
          let json = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          console.log(json);
          this.existingList = json;
          //     let functionData = {
          //   itemSlug: itemSlug,
          //   desc: item.title,
          //   titleSlug
          // };
        };
      }
    },
    create() {
      //   const createNewClientAdmin = firebase
      //     .functions()
      //     .httpsCallable("createNewClientAdmin");
      //   let sanitizedList = [];
      //   let draftList = JSON.parse(
      //     JSON.stringify(this.clientList).replace(/\s(?=\w+":)/g, "")
      //   );
      //   let finalList = JSON.parse(
      //     JSON.stringify(draftList).replace(/\s(?=\w+":)/g, "")
      //   );
      //   // JSON.parse(JSON.stringify(arr).replace(/\s(?=\w+":)/g, ""));
      //   // console.log("list:", finalList);

      //   finalList.forEach(item => {
      //     if (
      //       item.MailingAddress &&
      //       item.FirstName &&
      //       item.LastName &&
      //       item.Phone
      //     ) {
      //       // console.log("mailing address", item["Mailing Address"]);
      //       // console.log(item);
      //       let propertySlug = slugify(item.MailingAddress, {
      //         replacement: "-",
      //         remove: /[$*_+~.()'"!\-:@,#]/g,
      //         lower: true
      //       });
      //       let nameAndPhone =
      //         item.FirstName + " " + item.LastName + " " + item.Phone;
      //       let tempEmail =
      //         item.FirstName.toLowerCase() +
      //         "." +
      //         item.LastName.toLowerCase() +
      //         "@taplaw.com";
      //       let email = tempEmail.toString();
      //       console.log("email", email);
      //       let uid = slugify(nameAndPhone, {
      //         replacement: "-",
      //         remove: /[$*_+~.()'"!\-:@,]/g,
      //         lower: true
      //       });

      //       let newClient = {
      //         propertySlug: propertySlug,
      //         email: email,
      //         password: item.Phone,
      //         uid: uid,
      //         firstName: item.FirstName,
      //         lastName: item.LastName,
      //         phone: item.Phone,
      //         streetAddress: item.MailingAddress,

      //         caseNumber: item.CaseNumber,
      //         client_ID: item.Client_ID,
      //         actualEmail: item.Email,

      //         city: item.MailingCity,
      //         state: item.MailingState,
      //         zip: item.MailingZipCode,

      //         secondaryEmail: item.SecondaryEmail,
      //         secondaryPhone: item.SecondaryPhone
      //       };
      //       console.log(newClient);
      //       sanitizedList.push(newClient);
      //     }
      //   });
      //   console.log(sanitizedList);
      //   // sanitizedList.forEach(item => {
      //   //   console.log("launching cloud fuction for", item);
      //   //   createNewClientAdmin(item);
      //   // });
      //   createNewClientAdmin(sanitizedList);
      // }
      // ***************^^^ ABOVE WORKS FOR ADDING IN BULK FROM CLIENT LIST***********

      // ***************vvvv BELOW WORKS FOR ADDING A SINGLE CLIENT FORM UI***********
      // firebase
      //   .app()
      //   .functions()
      //   .useFunctionsEmulator("http://localhost:5001");
      this.loading = true;
      const createNewClientAdmin = firebase
        .functions()
        .httpsCallable("createNewClientAdmin");
      let propertySlug = slugify(this.streetAddress, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,#]/g,
        lower: true
      });
      let nameAndPhone =
        this.firstName.trim() + " " + this.lastName.trim() + " " + this.phone;
      console.log("nameAndPhone", nameAndPhone);

      let finalLastName = slugify(this.lastName, {
        replacement: "_",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });

      let email =
        this.firstName.trim().toLowerCase() +
        "." +
        finalLastName.trim().toLowerCase() +
        "@taplaw.com";
      let uid = slugify(nameAndPhone, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      let matterID = uid + "-" + propertySlug;
      let newClient = {
        matterID: matterID,
        propertySlug: propertySlug,
        email: email,
        password: this.phone,
        uid: uid,
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        caseID: this.caseID,
        streetAddress: this.streetAddress,
        firmName: this.user.firmName,
        firmAddressLine: this.user.firmAddressLine,
        firmCityStateZip: this.user.firmCityStateZip,
        firmPhone: this.user.phone,
        firmSlug: this.user.firmSlug,
        contentsListCompleted: false,
        user: this.user
      };
      if (this.existingList !== null) {
        newClient.existingList = true;
      }
      console.log(newClient);
      createNewClientAdmin(newClient)
        .then(resp => {
          alert(resp);
          console.log(resp);
          //if client has a preloaded contents list
          if (newClient.existingList) {
            // " QTY ": 1
            // CATEGORY: "Living Room"
            // DESCRIPTION: "Chair wingback with ottoman"
            // NOTES: "Seagrass "
            // SOURCE: "Pottery Barn"
            // call a cloud function for get procing

            //launch pricing for each item
            this.existingList.forEach(async item => {
              if (item.DESCRIPTION && item.DESCRIPTION !== "") {
                let ref = Math.floor(Math.random() * 90000) + 10000;
                let cat = "";
                if (item.CATEGORY && item.CATEGORY !== "") {
                  cat = item.CATEGORY.trim().toUpperCase();
                } else {
                  cat = "Other";
                }

                let title = item.DESCRIPTION;
                title = title.replace(/-/g, " ");
                title = title.replace(/\//g, " ").trim();
                title = title.toLowerCase();
                // let search = "";
                // if (cat && cat !== "Other") {
                //   search = cat.replace(/\//g, " ").toLowerCase() + " " + title;
                // }
                let desc = "";
                // let notes = "";
                if (item.NOTES && item.NOTES !== "") {
                  desc = item.NOTES.toLowerCase()
                    .replaceAll("-", " ")
                    .replace(/\//g, " ")
                    .trim();
                }
                // let source = "";
                // if (item.SOURCE && item.SOURCE !== "") {
                //   source = item.SOURCE.toLowerCase()
                //     .replaceAll("-", " ")
                //     .replaceAll("/", " ")
                //     .trim();

                //   search = search + " " + source;
                // }
                let quantity = null;
                if (item["QTY"] && item["QTY"] !== "") {
                  quantity = item["QTY"];
                }
                // let searchTerms = slugify(search, {
                //   replacement: "+",
                //   remove: /[$*_+~.()'"!\-:@,#]/g,
                //   lower: true
                // });
                //old version
                // let newItem = {
                //   title,
                //   ref,
                //   category: cat,
                //   userDescription: desc,
                //   comment: null,
                //   notes,
                //   source,
                //   quantity,
                //   pricing: null,
                //   searchTerms: search
                // };
                //new version
                let newItem = {
                  title,
                  ref,
                  category: cat,
                  userDescription: desc,
                  comment: null,
                  quantity
                };
                console.log(`launching pricing for: ${title}`, newItem);

                await
                  firebase
                    .firestore()
                    .collection("fireMatters")
                    .doc(matterID)
                    .collection("contentsList")
                    .doc(newItem.title)
                    .set(newItem)
                    .then(() => {
                      console.log("item saved to user's contents list");
                    }).catch(e => console.error(e.message));


                // let title = item.description.replace(/ *\([^)]*\) */g, "")

                //   let itemSlug = searchTerms;
                //   let titleSlug = slugify(title, {
                //     replacement: "-",
                //     remove: /[$*_+~.()'"!\-:@,#]/g,
                //     lower: true
                //   });
                //   let functionData = {
                //     itemSlug: itemSlug,
                //     desc: title,
                //     titleSlug
                //   };

                //   const getPricing2 = firebase
                //     .app()
                //     .functions("us-west2")
                //     .httpsCallable("getPricing2", { timeout: 0 });

                //   await firebase
                //     .firestore()
                //     .collection("pricedItemList")
                //     .doc(searchTerms)
                //     .get()
                //     .then(async resp => {
                //       //IF THERE IS A PRICING OBJECT IN THE DATABASE
                //       if (resp.exists == true) {
                //         console.log("hell ya it exists!");
                //         //set the pricing to the response from get(existingPricing data)
                //         newItem.pricing = await resp.data();
                //         await firebase
                //           .firestore()
                //           .collection("fireMatters")
                //           .doc(matterID)
                //           .collection("contentsList")
                //           .doc(searchTerms)
                //           .set(newItem)
                //           .then(() => {
                //             console.log("item saved to user's contents list");
                //           })
                //           .catch(e => console.error(e.message));
                //       } else {
                //         await getPricing2(functionData)
                //           .then(async resp => {
                //             let pricing = await resp.data;
                //             pricing.searchTerms = searchTerms;
                //             if (
                //               pricing.pdfPath !== null &&
                //               pricing.pdfPath !== undefined
                //             ) {
                //               //if ther is a pdfPath property (this is actually a .png)
                //               //get the download url for the new pricing screenshot
                //               let screenShotRef = firebase
                //                 .storage()
                //                 .refFromURL(
                //                   `gs://taplaw.appspot.com/${pricing.pdfPath}`
                //                 );
                //               // console.log("pricing.pdfPath", pricing.pdfPath);

                //               await screenShotRef
                //                 .getDownloadURL()
                //                 .then(url => {
                //                   pricing.downloadUrl = url;
                //                   this.showScreenShotSrc = url;
                //                   pricing.pricingError = null;
                //                 })
                //                 .catch(err => {
                //                   pricing.pricingError = err;
                //                   console.log("err", err);
                //                 });
                //             } else {
                //               //if there is no pdfPath (this is actually a .png)
                //               pricing.downloadUrl = null;
                //             }
                //             //set the item's pricing
                //             newItem.pricing = await pricing;
                //             // console.log("item.pricing", newItem.pricing);
                //             await firebase
                //               .firestore()
                //               .collection("fireMatters")
                //               .doc(matterID)
                //               .collection("contentsList")
                //               .doc(searchTerms)
                //               .set(newItem)
                //               .then(() => {
                //                 // console.log("item saved to user's contents list");
                //                 if (newItem.pricing !== null) {
                //                   firebase
                //                     .firestore()
                //                     //may have to change this to pricedItemList
                //                     .collection("otherPricedItems")
                //                     .doc(newItem.pricing.searchTerms)
                //                     .set(newItem.pricing)
                //                     .then(() => {
                //                       console.log(
                //                         "item saved to otherPricedItems"
                //                       );
                //                     })
                //                     .catch(err => {
                //                       console.log("err", err);
                //                     });
                //                 }
                //               })
                //               .catch(e => console.error(e.message));
                //           })
                //           .catch(err => {
                //             console.log(err.message);
                //             console.log("item in error", item);

                //             console.log("trying this item again");
                //             getPricing2(functionData).then(async resp => {
                //               let pricing = await resp.data;
                //               pricing.searchTerms = searchTerms;
                //               if (
                //                 pricing.pdfPath !== null &&
                //                 pricing.pdfPath !== undefined
                //               ) {
                //                 //if ther is a pdfPath property (this is actually a .png)
                //                 //get the download url for the new pricing screenshot
                //                 let screenShotRef = firebase
                //                   .storage()
                //                   .refFromURL(
                //                     `gs://taplaw.appspot.com/${pricing.pdfPath}`
                //                   );
                //                 // console.log("pricing.pdfPath", pricing.pdfPath);

                //                 await screenShotRef
                //                   .getDownloadURL()
                //                   .then(url => {
                //                     pricing.downloadUrl = url;
                //                     this.showScreenShotSrc = url;
                //                     pricing.pricingError = null;
                //                   })
                //                   .catch(err => {
                //                     pricing.pricingError = err;
                //                     console.log("err", err);
                //                   });
                //               } else {
                //                 //if there is no pdfPath (this is actually a .png)
                //                 pricing.downloadUrl = null;
                //               }
                //               //set the item's pricing
                //               newItem.pricing = await pricing;
                //               // console.log("item.pricing", item.pricing);
                //               await firebase
                //                 .firestore()
                //                 .collection("fireMatters")
                //                 .doc(matterID)
                //                 .collection("contentsList")
                //                 .doc(searchTerms)
                //                 .set(newItem)
                //                 .then(() => {
                //                   console.log(
                //                     "item saved to user's contents list"
                //                   );
                //                   if (newItem.pricing !== null) {
                //                     firebase
                //                       .firestore()
                //                       .collection("otherPricedItems")
                //                       .doc(newItem.pricing.searchTerms)
                //                       .set(newItem.pricing)
                //                       .then(() => {
                //                         console.log(
                //                           "item saved to otherPricedItems"
                //                         );
                //                       })
                //                       .catch(err => {
                //                         console.log("err", err);
                //                       });
                //                     this.loading = false;
                //                   }
                //                 })
                //                 .catch(e => console.error(e.message));
                //             });
                //           });
                //       }
                //     });
              }
            }); //end forEach loop on existingList
          }
          //get cleint with uid
        })
        .then(() => {
          this.loading = false;
          this.firstName = null;
          this.lastName = null;
          this.fullName = null;
          this.email = null;
          this.phone = null;
          this.caseID = null;
          this.streetAddress = null;
        })
        .catch(e => {
          alert(e.message);
        });
    }
    ///////////////////////////////////////////////////////////////

    // onLogin() {
    //   this.$store.dispatch("signUserIn", {
    //     email: this.email,
    //     password: this.password,
    //   });
    //   // this.$router.push("/");
    // },
    // // onDismissed() {
    // //   console.log("dismissed alert");
    // //   this.$store.dispatch("clearError");
    // // }
  }
};
</script>

<style scoped></style>
